/* Ardor Banner Builder - artwork previews (PDF, AI, EPS, TIFF, PSD).
   PDF and PDF-compatible AI pages are drawn with Mozilla pdf.js (Apache-2.0, loaded on demand).
   EPS files are turned into a small PDF by a mini PostScript reader below, or use their built-in TIFF preview. */
(function () {
  'use strict';

  var MAX_AREA = 6000000;

  function latin1(b, s, e) { var out = '', CH = 8192; s = s || 0; e = e == null ? b.length : e; for (var i = s; i < e; i += CH) out += String.fromCharCode.apply(null, b.subarray(i, Math.min(e, i + CH))); return out; }
  function makeCanvas(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function cmykToRgb(c, m, y, k) {
    // simple press-like conversion (good enough for an on-screen preview)
    var r = 255 * (1 - Math.min(1, c * 0.93 + k)), g = 255 * (1 - Math.min(1, m * 0.9 + c * 0.08 + k)), b = 255 * (1 - Math.min(1, y * 0.88 + m * 0.04 + c * 0.02 + k));
    return [r < 0 ? 0 : r, g < 0 ? 0 : g, b < 0 ? 0 : b];
  }
  function inflateAsync(bytes, raw) {
    if (typeof DecompressionStream === 'undefined') return Promise.reject(new Error('no inflate'));
    var ds = new DecompressionStream(raw ? 'deflate-raw' : 'deflate');
    var w = ds.writable.getWriter(); w.write(bytes).catch(function () {}); w.close().catch(function () {});
    return new Response(ds.readable).arrayBuffer().then(function (ab) { return new Uint8Array(ab); });
  }

  // ---------- pdf.js ----------
  var URLS = { lib: '', worker: '' };
  var pdfjsP = null;
  // load an ES module from a classic script (Shopify's asset minifier rewrites a direct dynamic import)
  function importModule(url) {
    return new Promise(function (res, rej) {
      var key = 'ardorMod' + Math.random().toString(36).slice(2), done = false, K = JSON.stringify(key);
      window.addEventListener(key, function () {
        done = true; var m = window[key]; try { delete window[key]; } catch (e) { window[key] = undefined; }
        if (!m || m.__err) rej(new Error((m && m.__err) || 'module')); else res(m);
      }, { once: true });
      var s = document.createElement('script'); s.type = 'module';
      s.textContent = 'imp' + 'ort(' + JSON.stringify(url) + ').then(function (m) { window[' + K + '] = m; }, function (e) { window[' + K + '] = { __err: String((e && e.message) || e) }; }).then(function () { window.dispatchEvent(new Event(' + K + ')); });';
      document.head.appendChild(s);
      setTimeout(function () { if (!done) rej(new Error('module timeout')); }, 30000);
    });
  }
  function loadPdfjs() {
    if (pdfjsP) return pdfjsP;
    if (!URLS.lib) return Promise.reject(new Error('pdf viewer not configured'));
    pdfjsP = importModule(URLS.lib).then(function (m) {
      if (URLS.worker) m.GlobalWorkerOptions.workerSrc = URLS.worker;
      return m;
    }).catch(function (e) { pdfjsP = null; throw e; });
    return pdfjsP;
  }
  function isBlank(cv) {
    var w = Math.min(cv.width, 200), h = Math.min(cv.height, 200);
    var t = makeCanvas(w, h), x = t.getContext('2d');
    x.drawImage(cv, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data;
    for (var i = 3; i < d.length; i += 4) if (d[i] > 8) return false;
    return true;
  }
  // render page 1 of a PDF to a canvas whose long side is about maxPx
  function renderPdf(bytes, maxPx) {
    return loadPdfjs().then(function (pdfjs) {
      var task = pdfjs.getDocument({ data: bytes.slice(), isEvalSupported: false, verbosity: 0, useSystemFonts: true });
      return task.promise.then(function (doc) {
        return doc.getPage(1).then(function (page) {
          var v1 = page.getViewport({ scale: 1 });
          var s = Math.min(maxPx / Math.max(v1.width, v1.height), Math.sqrt(MAX_AREA / Math.max(1, v1.width * v1.height)));
          var vp = page.getViewport({ scale: s });
          var cv = makeCanvas(Math.ceil(vp.width), Math.ceil(vp.height));
          return page.render({ canvas: cv, canvasContext: cv.getContext('2d'), viewport: vp, intent: 'print', annotationMode: 0, background: 'rgba(0,0,0,0)' }).promise.then(function () {
            return page.getTextContent().then(function (tc) {
              return tc.items.map(function (it) { return it.str || ''; }).join(' ');
            }).catch(function () { return ''; });
          }).then(function (txt) {
            var res = { canvas: cv, natW: v1.width, natH: v1.height, text: txt };
            try { doc.destroy(); } catch (e) {}
            return res;
          });
        });
      });
    });
  }

  // ---------- TIFF ----------
  function lzwDecode(data, early) {
    var out = new Uint8Array(Math.max(4096, data.length * 3)), op = 0;
    var prefix = new Int32Array(4096), suffix = new Uint8Array(4096), len = new Uint16Array(4096), first = new Uint8Array(4096);
    for (var i = 0; i < 256; i++) { prefix[i] = -1; suffix[i] = i; len[i] = 1; first[i] = i; }
    var next = 258, cl = 9, prev = -1, bitBuf = 0, bitCnt = 0, p = 0;
    var ensure = function (n) { if (op + n > out.length) { var o2 = new Uint8Array(Math.max(out.length * 2, op + n + 4096)); o2.set(out); out = o2; } };
    var put = function (code) { var L = len[code]; ensure(L); var pos = op + L - 1, c = code; while (c >= 0 && pos >= op) { out[pos--] = suffix[c]; c = prefix[c]; } op += L; };
    for (;;) {
      while (bitCnt < cl) { if (p >= data.length) return out.subarray(0, op); bitBuf = ((bitBuf << 8) | data[p++]) >>> 0; bitCnt += 8; }
      var code = (bitBuf >>> (bitCnt - cl)) & ((1 << cl) - 1); bitCnt -= cl;
      if (code === 256) { next = 258; cl = 9; prev = -1; continue; }
      if (code === 257) break;
      if (prev === -1) { if (code > 255) break; put(code); prev = code; continue; }
      var fc;
      if (code < next) { put(code); fc = first[code]; }
      else if (code === next) { fc = first[prev]; ensure(len[prev] + 1); put(prev); out[op++] = fc; }
      else break;
      if (next < 4096) { prefix[next] = prev; suffix[next] = fc; len[next] = len[prev] + 1; first[next] = first[prev]; next++; }
      if (next + early >= (1 << cl) && cl < 12) cl++;
      prev = code;
    }
    return out.subarray(0, op);
  }
  function packBits(data, expect) {
    var out = new Uint8Array(expect || data.length * 4), op = 0, p = 0;
    while (p < data.length && op < out.length) {
      var n = data[p++];
      if (n < 128) { var c = n + 1; for (var i = 0; i < c && p < data.length && op < out.length; i++) out[op++] = data[p++]; }
      else if (n > 128) { var r = 257 - n, v = data[p++]; for (var j = 0; j < r && op < out.length; j++) out[op++] = v; }
    }
    return out.subarray(0, op);
  }
  function decodeTiff(b) {
    var dv = new DataView(b.buffer, b.byteOffset, b.byteLength), le = b[0] === 0x49;
    var u16 = function (o) { return dv.getUint16(o, le); }, u32 = function (o) { return dv.getUint32(o, le); };
    if (u16(2) !== 42) return Promise.reject(new Error('not tiff'));
    var ifd = u32(4), n = u16(ifd), T = {};
    var SZ = { 1: 1, 2: 1, 3: 2, 4: 4, 5: 8, 6: 1, 7: 1, 8: 2, 9: 4, 10: 8, 11: 4, 12: 8 };
    for (var i = 0; i < n; i++) {
      var e = ifd + 2 + i * 12, tag = u16(e), type = u16(e + 2), cnt = u32(e + 4), sz = (SZ[type] || 1) * cnt;
      var off = sz <= 4 ? e + 8 : u32(e + 8), vals = [];
      if (off + sz > b.length) continue;
      for (var k = 0; k < cnt && k < 100000; k++) {
        if (type === 3 || type === 8) vals.push(u16(off + 2 * k));
        else if (type === 4 || type === 9) vals.push(u32(off + 4 * k));
        else if (type === 5) vals.push(u32(off + 8 * k) / (u32(off + 8 * k + 4) || 1));
        else vals.push(b[off + k]);
      }
      T[tag] = vals;
    }
    var W = (T[256] || [0])[0], H = (T[257] || [0])[0];
    if (!W || !H || W * H > 60000000) return Promise.reject(new Error('tiff size'));
    var bps = (T[258] || [1])[0], comp = (T[259] || [1])[0], photo = (T[262] || [1])[0], spp = (T[277] || [1])[0];
    var planar = (T[284] || [1])[0], pred = (T[317] || [1])[0], cmap = T[320], extra = T[338] || [];
    if (planar !== 1 && spp > 1) return Promise.reject(new Error('planar tiff'));
    if ([1, 5, 8, 32946, 32773].indexOf(comp) < 0) return Promise.reject(new Error('tiff compression ' + comp));
    var units = [];
    if (T[322]) {
      var tw = T[322][0], th = T[323][0], toffs = T[324], tcnt = T[325], across = Math.ceil(W / tw);
      toffs.forEach(function (o, ti) { units.push({ x: (ti % across) * tw, y: Math.floor(ti / across) * th, w: tw, h: th, off: o, len: tcnt[ti] }); });
    } else {
      var rps = (T[278] || [H])[0], soffs = T[273] || [], scnt = T[279] || [];
      soffs.forEach(function (o, si) { units.push({ x: 0, y: si * rps, w: W, h: Math.min(rps, H - si * rps), off: o, len: scnt[si] || (b.length - o) }); });
    }
    var cv = makeCanvas(W, H), ctx = cv.getContext('2d'), img = ctx.createImageData(W, H), px = img.data;
    var bytesPer = function (w) { return Math.ceil(w * spp * bps / 8); };
    var chain = Promise.resolve();
    units.forEach(function (u) {
      chain = chain.then(function () {
        var raw = b.subarray(u.off, Math.min(b.length, u.off + u.len)), rowLen = bytesPer(u.w), need = rowLen * u.h;
        if (comp === 1) return raw;
        if (comp === 5) return lzwDecode(raw, 1);
        if (comp === 32773) return packBits(raw, need);
        return inflateAsync(raw).catch(function () { return inflateAsync(raw.subarray(2), true); });
      }).then(function (d) {
        var rowLen = bytesPer(u.w);
        if (pred === 2 && bps === 8) for (var r = 0; r < u.h; r++) for (var x = spp; x < u.w * spp; x++) { var q = r * rowLen + x; if (q < d.length) d[q] = (d[q] + d[q - spp]) & 255; }
        var sample = function (row, idx) { // idx = sample index in row
          if (bps === 8) return d[row * rowLen + idx];
          if (bps === 16) return d[row * rowLen + idx * 2 + (le ? 1 : 0)];
          var bit = idx * bps, byte = d[row * rowLen + (bit >> 3)], sh = 8 - bps - (bit & 7);
          var v = (byte >> sh) & ((1 << bps) - 1);
          return photo === 3 ? v : Math.round(v * 255 / ((1 << bps) - 1));
        };
        var palMax = cmap ? (1 << bps) : 0;
        for (var y = 0; y < u.h; y++) {
          var Y = u.y + y; if (Y >= H) break;
          for (var x2 = 0; x2 < u.w; x2++) {
            var X = u.x + x2; if (X >= W) continue;
            var o = (Y * W + X) * 4, s0 = x2 * spp, R, G, B, A = 255;
            if (photo === 2) { R = sample(y, s0); G = sample(y, s0 + 1); B = sample(y, s0 + 2); if (spp > 3 && extra.length) { A = sample(y, s0 + 3); if (extra[0] === 1 && A) { R = Math.min(255, R * 255 / A); G = Math.min(255, G * 255 / A); B = Math.min(255, B * 255 / A); } } }
            else if (photo === 3 && cmap) { var ix = sample(y, s0); R = cmap[ix] >> 8; G = cmap[palMax + ix] >> 8; B = cmap[2 * palMax + ix] >> 8; }
            else if (photo === 5) { var cc = cmykToRgb(sample(y, s0) / 255, sample(y, s0 + 1) / 255, sample(y, s0 + 2) / 255, sample(y, s0 + 3) / 255); R = cc[0]; G = cc[1]; B = cc[2]; if (spp > 4 && extra.length) A = sample(y, s0 + 4); }
            else { var gv = sample(y, s0); if (photo === 0) gv = 255 - gv; R = G = B = gv; if (spp > 1 && extra.length) A = sample(y, s0 + 1); }
            px[o] = R; px[o + 1] = G; px[o + 2] = B; px[o + 3] = A;
          }
        }
      });
    });
    return chain.then(function () { ctx.putImageData(img, 0, 0); return cv; });
  }

  // ---------- PSD / PSB (merged image) ----------
  function decodePsd(b) {
    var dv = new DataView(b.buffer, b.byteOffset, b.byteLength);
    if (latin1(b, 0, 4) !== '8BPS') return Promise.reject(new Error('not psd'));
    var ver = dv.getUint16(4), ch = dv.getUint16(12), H = dv.getUint32(14), W = dv.getUint32(18), depth = dv.getUint16(22), mode = dv.getUint16(24);
    if (!W || !H || W * H > 60000000) return Promise.reject(new Error('psd size'));
    var p = 26, cmLen = dv.getUint32(p); var cmStart = p + 4; p = cmStart + cmLen;
    var resLen = dv.getUint32(p); p += 4 + resLen;
    var lmLen = ver === 2 ? dv.getUint32(p) * 4294967296 + dv.getUint32(p + 4) : dv.getUint32(p); p += (ver === 2 ? 8 : 4) + lmLen;
    var compr = dv.getUint16(p); p += 2;
    var bpr = Math.ceil(W * depth / 8), planes = [];
    var useCh = mode === 4 ? 4 : (mode === 3 || mode === 9 ? 3 : 1);
    if (compr === 0) {
      for (var c = 0; c < Math.min(ch, useCh); c++) planes.push(b.subarray(p + c * bpr * H, p + (c + 1) * bpr * H));
    } else if (compr === 1) {
      var cntSz = ver === 2 ? 4 : 2, counts = [], q = p;
      for (var i = 0; i < ch * H; i++) { counts.push(cntSz === 4 ? dv.getUint32(q) : dv.getUint16(q)); q += cntSz; }
      for (var c2 = 0; c2 < Math.min(ch, useCh); c2++) {
        var plane = new Uint8Array(bpr * H);
        for (var r = 0; r < H; r++) { var n = counts[c2 * H + r]; plane.set(packBits(b.subarray(q, q + n), bpr), r * bpr); q += n; }
        planes.push(plane);
      }
    } else return Promise.reject(new Error('psd compression'));
    var cv = makeCanvas(W, H), ctx = cv.getContext('2d'), img = ctx.createImageData(W, H), px = img.data;
    var get = function (pl, i) { if (depth === 8) return pl[i]; if (depth === 16) return pl[i * 2]; return ((pl[i >> 3] >> (7 - (i & 7))) & 1) ? 0 : 255; };
    var rowIdx = function (y, x) { return depth === 1 ? y * bpr * 8 + x : y * W + x; };
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
      var o = (y * W + x) * 4, k = rowIdx(y, x), R, G, B;
      if (mode === 3) { R = get(planes[0], k); G = get(planes[1], k); B = get(planes[2], k); }
      else if (mode === 4) { var cc = cmykToRgb(1 - get(planes[0], k) / 255, 1 - get(planes[1], k) / 255, 1 - get(planes[2], k) / 255, 1 - get(planes[3], k) / 255); R = cc[0]; G = cc[1]; B = cc[2]; }
      else if (mode === 2) { var ix = get(planes[0], k); R = b[cmStart + ix]; G = b[cmStart + 256 + ix]; B = b[cmStart + 512 + ix]; }
      else if (mode === 9) { var L = get(planes[0], k) * 100 / 255, a = get(planes[1], k) - 128, bb = get(planes[2], k) - 128; var lab = labToRgb(L, a, bb); R = lab[0]; G = lab[1]; B = lab[2]; }
      else { R = G = B = get(planes[0], k); }
      px[o] = R; px[o + 1] = G; px[o + 2] = B; px[o + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    return Promise.resolve(cv);
  }
  function labToRgb(L, a, b) {
    var fy = (L + 16) / 116, fx = fy + a / 500, fz = fy - b / 200;
    var f = function (t) { return t > 6 / 29 ? t * t * t : 3 * (6 / 29) * (6 / 29) * (t - 4 / 29); };
    var X = 0.9642 * f(fx), Y = f(fy), Z = 0.8249 * f(fz);
    var r = 3.1339 * X - 1.6169 * Y - 0.4906 * Z, g = -0.9788 * X + 1.9161 * Y + 0.0335 * Z, bl = 0.0719 * X - 0.2290 * Y + 1.4052 * Z;
    var gm = function (v) { v = v <= 0.0031308 ? 12.92 * v : 1.055 * Math.pow(Math.max(0, v), 1 / 2.4) - 0.055; return Math.max(0, Math.min(255, Math.round(v * 255))); };
    return [gm(r), gm(g), gm(bl)];
  }

  // =====================================================================
  // EPS: a small PostScript reader that turns the drawing into a PDF page
  // (paths, fills, strokes, clips, CMYK/RGB/gray/spot colors, gradients, images).
  // Text that isn't outlined is not supported; those files use their preview or the email-proof path.
  // =====================================================================
  function PSName(v, x) { this.v = v; this.x = x; }
  function PSStr(b) { this.b = b; }
  function PSArr(a, x) { this.a = a; this.x = x; }
  function PSDict() { this.m = new Map(); }
  function PSOp(name, f) { this.name = name; this.f = f; }
  function PSFilter(name, src, parms) { this.name = name; this.src = src; this.parms = parms; this.buf = null; this.pos = 0; this.eod = false; }
  function PSFile(it) { this.it = it; }
  function PSSave(depth) { this.depth = depth; }
  var MARK = { mark: true }, EOF = { eof: true };
  function Unsupported(msg) { this.msg = msg; }
  function StopSig() {}
  function ExitSig() {}

  var WS = new Uint8Array(256); [0, 9, 10, 12, 13, 32].forEach(function (c) { WS[c] = 1; });
  var DL = new Uint8Array(256); '()<>[]{}/%'.split('').forEach(function (c) { DL[c.charCodeAt(0)] = 1; });
  var NUMRE = /^[+-]?(\d+\.?\d*|\.\d+)([eE][+-]?\d+)?$/, RADIXRE = /^(\d+)#([0-9A-Za-z]+)$/;

  function a85(b, s, e) { // decode ASCII85 between s and e (excluding '~>')
    var out = [], tup = 0, n = 0;
    for (var i = s; i < e; i++) {
      var c = b[i];
      if (WS[c]) continue;
      if (c === 122 && n === 0) { out.push(0, 0, 0, 0); continue; }
      if (c < 33 || c > 117) continue;
      tup = tup * 85 + (c - 33); n++;
      if (n === 5) { out.push((tup >>> 24) & 255, (tup >>> 16) & 255, (tup >>> 8) & 255, tup & 255); tup = 0; n = 0; }
    }
    if (n > 1) { for (var k = n; k < 5; k++) tup = tup * 85 + 84; var t4 = [(tup >>> 24) & 255, (tup >>> 16) & 255, (tup >>> 8) & 255, tup & 255]; for (var j = 0; j < n - 1; j++) out.push(t4[j]); }
    return new Uint8Array(out);
  }
  function ahx(b, s, e) {
    var out = [], hi = -1;
    for (var i = s; i < e; i++) {
      var c = b[i], v = c >= 48 && c <= 57 ? c - 48 : (c >= 65 && c <= 70 ? c - 55 : (c >= 97 && c <= 102 ? c - 87 : -1));
      if (v < 0) continue;
      if (hi < 0) hi = v; else { out.push(hi * 16 + v); hi = -1; }
    }
    if (hi >= 0) out.push(hi * 16);
    return new Uint8Array(out);
  }
  function hexEsc(b) { var s = '<'; for (var i = 0; i < b.length; i++) s += (b[i] < 16 ? '0' : '') + b[i].toString(16); return s + '>'; }
  function pdfName(s) { return '/' + String(s).replace(/[^!-~]|[#()<>\[\]{}\/%]/g, function (ch) { var c = ch.charCodeAt(0) & 255; return '#' + (c < 16 ? '0' : '') + c.toString(16); }); }
  function fmt(n) { if (!isFinite(n)) n = 0; var r = Math.round(n * 10000) / 10000; return (Math.abs(r) < 1e-9 ? 0 : r).toString(); }
  function mmul(m, n) { return [m[0] * n[0] + m[1] * n[2], m[0] * n[1] + m[1] * n[3], m[2] * n[0] + m[3] * n[2], m[2] * n[1] + m[3] * n[3], m[4] * n[0] + m[5] * n[2] + n[4], m[4] * n[1] + m[5] * n[3] + n[5]]; }
  function minv(m) { var d = m[0] * m[3] - m[1] * m[2]; if (Math.abs(d) < 1e-12) return null; return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[3] * m[4]) / d, (m[1] * m[4] - m[0] * m[5]) / d]; }
  function tp(m, x, y) { return [m[0] * x + m[2] * y + m[4], m[1] * x + m[3] * y + m[5]]; }

  // ---- tiny PDF writer for the converted page ----
  function MiniPdf() { this.objs = [null]; }
  MiniPdf.prototype.add = function (dict, data) { this.objs.push({ d: dict, s: data || null }); return this.objs.length - 1; };
  MiniPdf.prototype.bytes = function (rootDict) {
    var root = this.add(rootDict), enc = function (s) { var u = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) u[i] = s.charCodeAt(i) & 255; return u; };
    var chunks = [], off = 0, offs = [0];
    var push = function (u) { chunks.push(u); off += u.length; };
    push(enc('%PDF-1.5\n%\xE2\xE3\xCF\xD3\n'));
    for (var i = 1; i < this.objs.length; i++) {
      var o = this.objs[i]; offs.push(off);
      if (o.s) { push(enc(i + ' 0 obj\n' + o.d.replace(/>>\s*$/, ' /Length ' + o.s.length + ' >>') + '\nstream\n')); push(o.s); push(enc('\nendstream\nendobj\n')); }
      else push(enc(i + ' 0 obj\n' + o.d + '\nendobj\n'));
    }
    var x = 'xref\n0 ' + this.objs.length + '\n0000000000 65535 f \n';
    for (var j = 1; j < offs.length; j++) x += String(offs[j]).padStart(10, '0') + ' 00000 n \n';
    push(enc(x + 'trailer\n<< /Size ' + this.objs.length + ' /Root ' + root + ' 0 R >>\nstartxref\n' + off + '\n%%EOF\n'));
    var n = 0; chunks.forEach(function (c) { n += c.length; }); var out = new Uint8Array(n), p = 0; chunks.forEach(function (c) { out.set(c, p); p += c.length; });
    return out;
  };

  function PS(src, start, end, dialect) {
    this.b = src; this.p = start; this.end = end; this.dialect = dialect;
    this.os = []; this.ds = []; this.steps = 0; this.unknown = {}; this.unsupported = null;
    this.pdf = new MiniPdf(); this.ops = []; this.res = { cs: [], sh: [], xo: [] }; this.paints = 0;
    this.gs = { ctm: [1, 0, 0, 1, 0, 0], path: [], cp: null, fill: { cs: 'DeviceGray', c: [0] }, stroke: { cs: 'DeviceGray', c: [0] }, lw: 1, cap: 0, join: 0, ml: 10, dash: [[], 0], rule: 0 };
    this.gstack = []; this.saves = []; this.resources = {}; this.compound = 0; this.pendingClip = 0; this.lastPaint = null; this.fillRule = 0;
    this.sys = new PSDict(); this.user = new PSDict(); this.ds = [this.sys, this.user];
    this.initOps();
  }
  PS.prototype.err = function (m) { throw new Error('ps: ' + m + ' (in ' + this.lastName + ' at ' + this.p + ')'); };
  PS.prototype.push = function (v) { this.os.push(v); };
  PS.prototype.pop = function () { if (!this.os.length) this.err('stackunderflow'); return this.os.pop(); };
  PS.prototype.num = function () { var v = this.pop(); if (typeof v !== 'number') { if (typeof v === 'boolean') return v ? 1 : 0; this.err('typecheck num'); } return v; };
  PS.prototype.nums = function (n) { var a = new Array(n); for (var i = n - 1; i >= 0; i--) a[i] = this.num(); return a; };
  PS.prototype.key = function (v) { return v instanceof PSName ? v.v : (v instanceof PSStr ? latin1(v.b) : (typeof v === 'number' ? 'n' + v : String(v))); };

  // ---- scanner ----
  PS.prototype.skipWs = function () {
    var b = this.b;
    for (;;) {
      while (this.p < this.end && WS[b[this.p]]) this.p++;
      if (this.p < this.end && b[this.p] === 37) { while (this.p < this.end && b[this.p] !== 10 && b[this.p] !== 13) this.p++; continue; }
      return;
    }
  };
  PS.prototype.token = function () {
    this.skipWs();
    var b = this.b; if (this.p >= this.end) return EOF;
    var c = b[this.p];
    if (c === 40) { // literal string
      var out = [], depth = 1; this.p++;
      while (this.p < this.end) {
        var ch = b[this.p++];
        if (ch === 92) {
          var e = b[this.p++];
          if (e === 110) out.push(10); else if (e === 114) out.push(13); else if (e === 116) out.push(9); else if (e === 98) out.push(8); else if (e === 102) out.push(12);
          else if (e === 13) { if (b[this.p] === 10) this.p++; }
          else if (e === 10) {}
          else if (e >= 48 && e <= 55) { var o = e - 48; for (var k = 0; k < 2 && b[this.p] >= 48 && b[this.p] <= 55; k++) o = o * 8 + b[this.p++] - 48; out.push(o & 255); }
          else out.push(e);
        } else if (ch === 40) { depth++; out.push(ch); }
        else if (ch === 41) { if (--depth === 0) break; out.push(ch); }
        else out.push(ch);
      }
      return new PSStr(new Uint8Array(out));
    }
    if (c === 60) {
      if (b[this.p + 1] === 60) { this.p += 2; return new PSName('<<', true); }
      if (b[this.p + 1] === 126) { var s = this.p + 2, e2 = s; while (e2 < this.end - 1 && !(b[e2] === 126 && b[e2 + 1] === 62)) e2++; this.p = e2 + 2; return new PSStr(a85(b, s, e2)); }
      var s2 = this.p + 1, e3 = s2; while (e3 < this.end && b[e3] !== 62) e3++; this.p = e3 + 1; return new PSStr(ahx(b, s2, e3));
    }
    if (c === 62) { if (b[this.p + 1] === 62) { this.p += 2; return new PSName('>>', true); } this.p++; return this.token(); }
    if (c === 91 || c === 93) { this.p++; return new PSName(c === 91 ? '[' : ']', true); }
    if (c === 123) { this.p++; return this.readProc(); }
    if (c === 125) { this.p++; return { closeProc: true }; }
    if (c === 41) { this.p++; return this.token(); }
    var lit = false, imm = false;
    if (c === 47) { this.p++; lit = true; if (b[this.p] === 47) { this.p++; imm = true; } }
    var st = this.p; while (this.p < this.end && !WS[b[this.p]] && !DL[b[this.p]]) this.p++;
    var t = latin1(b, st, this.p);
    if (this.p < this.end && WS[b[this.p]]) { if (b[this.p] === 13 && b[this.p + 1] === 10) this.p += 2; else this.p++; }
    if (lit) {
      if (imm) { var v = this.lookup(t); return v === undefined ? new PSName(t, true) : v; }
      return new PSName(t, false);
    }
    if (NUMRE.test(t)) return parseFloat(t);
    var rm = RADIXRE.exec(t); if (rm) return parseInt(rm[2], +rm[1]);
    if (!t) { this.p++; return this.token(); }
    return new PSName(t, true);
  };
  PS.prototype.readProc = function () {
    var a = [];
    for (;;) {
      var t = this.token();
      if (t === EOF) break;
      if (t && t.closeProc) break;
      a.push(t);
    }
    return new PSArr(a, true);
  };

  // ---- execution ----
  PS.prototype.lookup = function (n) {
    for (var i = this.ds.length - 1; i >= 0; i--) { var m = this.ds[i].m; if (m.has(n)) return m.get(n); }
    return undefined;
  };
  PS.prototype.execName = function (n) {
    this.lastName = n;
    var v = this.lookup(n);
    if (v === undefined) { this.unknown[n] = (this.unknown[n] || 0) + 1; return; }
    this.execObj(v);
  };
  PS.prototype.execObj = function (v) {
    if (++this.steps > 12000000) throw new Unsupported('too complex');
    if (v instanceof PSOp) v.f.call(this);
    else if (v instanceof PSArr && v.x) this.execProc(v);
    else if (v instanceof PSName && v.x) this.execName(v.v);
    else this.push(v);
  };
  PS.prototype.execProc = function (p) {
    var a = p.a;
    for (var i = 0; i < a.length; i++) {
      var e = a[i];
      if (e instanceof PSName && e.x) this.execName(e.v);
      else if (e instanceof PSOp) e.f.call(this);
      else this.push(e);
    }
  };
  PS.prototype.run = function () {
    for (;;) {
      var t = this.token();
      if (t === EOF) break;
      if (t && t.closeProc) continue;
      if (t instanceof PSName && t.x) this.execName(t.v); else this.push(t);
      if (this.unsupported) break;
    }
  };
  PS.prototype.call = function (proc, args, nOut) { // run a procedure on arguments, return results
    var base = this.os.length; args.forEach(function (a) { this.push(a); }, this);
    this.execObj(proc);
    var out = this.os.splice(base); return nOut ? out.slice(-nOut) : out;
  };
  PS.prototype.def = function (name, f) { this.sys.m.set(name, new PSOp(name, f)); };
  PS.prototype.alias = function (name, to) { var v = this.sys.m.get(to); if (v) this.sys.m.set(name, v); };
  PS.prototype.unsup = function (what) { if (!this.unsupported) this.unsupported = what; throw new Unsupported(what); };

  // ---- graphics -> PDF ----
  PS.prototype.addRes = function (kind, pdfText) { var list = this.res[kind]; var i = list.indexOf(pdfText); if (i < 0) { list.push(pdfText); i = list.length - 1; } return i; };
  PS.prototype.nComps = function (cs) {
    if (typeof cs === 'string') return cs === 'DeviceCMYK' ? 4 : (cs === 'DeviceRGB' ? 3 : 1);
    return cs.n;
  };
  PS.prototype.colorOp = function (col, stroke) {
    var c = col.c.map(fmt).join(' ');
    if (col.cs === 'DeviceGray') return c + (stroke ? ' G' : ' g');
    if (col.cs === 'DeviceRGB') return c + (stroke ? ' RG' : ' rg');
    if (col.cs === 'DeviceCMYK') return c + (stroke ? ' K' : ' k');
    var nm = '/CS' + this.addRes('cs', col.cs.pdf);
    return nm + (stroke ? ' CS ' : ' cs ') + c + (stroke ? ' SCN' : ' scn');
  };
  PS.prototype.pathOps = function (path, m) {
    var out = [];
    for (var i = 0; i < path.length; i++) {
      var s = path[i];
      if (s[0] === 'h') { out.push('h'); continue; }
      var pts = [];
      for (var k = 1; k < s.length; k += 2) { var q = m ? tp(m, s[k], s[k + 1]) : [s[k], s[k + 1]]; pts.push(fmt(q[0]), fmt(q[1])); }
      out.push(pts.join(' ') + ' ' + s[0]);
    }
    return out.join('\n');
  };
  PS.prototype.paintFill = function (eo, path) {
    path = path || this.gs.path; if (!path.length) return;
    this.ops.push(this.colorOp(this.gs.fill, false), this.pathOps(path), eo ? 'f*' : 'f'); this.paints++;
  };
  PS.prototype.paintStroke = function (path) {
    var g = this.gs; path = path || g.path; if (!path.length) return;
    var inv = minv(g.ctm); if (!inv) return;
    var dash = g.dash[0].length ? '[' + g.dash[0].map(fmt).join(' ') + '] ' + fmt(g.dash[1]) + ' d ' : '';
    this.ops.push('q ' + g.ctm.map(fmt).join(' ') + ' cm ' + fmt(g.lw) + ' w ' + g.cap + ' J ' + g.join + ' j ' + fmt(Math.max(1, g.ml)) + ' M ' + dash + this.colorOp(g.stroke, true), this.pathOps(path, inv), 'S Q'); this.paints++;
  };
  PS.prototype.clipPath = function (eo) { if (!this.gs.path.length) return; this.ops.push(this.pathOps(this.gs.path), eo ? 'W* n' : 'W n'); };
  PS.prototype.newPath = function () { this.gs.path = []; this.gs.cp = null; };
  PS.prototype.moveTo = function (x, y) { var q = tp(this.gs.ctm, x, y); this.gs.path.push(['m', q[0], q[1]]); this.gs.cp = q; this.gs.sp = q; };
  PS.prototype.lineTo = function (x, y) { var q = tp(this.gs.ctm, x, y); if (!this.gs.cp) { this.gs.path.push(['m', q[0], q[1]]); this.gs.sp = q; } else this.gs.path.push(['l', q[0], q[1]]); this.gs.cp = q; };
  PS.prototype.curveTo = function (x1, y1, x2, y2, x3, y3) {
    var m = this.gs.ctm, a = tp(m, x1, y1), b = tp(m, x2, y2), c = tp(m, x3, y3);
    if (!this.gs.cp) { this.gs.path.push(['m', a[0], a[1]]); this.gs.sp = a; }
    this.gs.path.push(['c', a[0], a[1], b[0], b[1], c[0], c[1]]); this.gs.cp = c;
  };
  PS.prototype.closePath = function () { if (this.gs.path.length) { this.gs.path.push(['h']); if (this.gs.sp) this.gs.cp = this.gs.sp; } };
  PS.prototype.userCp = function () { var inv = minv(this.gs.ctm); if (!this.gs.cp || !inv) this.err('nocurrentpoint'); return tp(inv, this.gs.cp[0], this.gs.cp[1]); };
  PS.prototype.arc = function (x, y, r, a1, a2, neg) {
    var rad = Math.PI / 180;
    if (neg) { while (a2 > a1) a2 -= 360; } else { while (a2 < a1) a2 += 360; }
    var sweep = (a2 - a1) * rad, n = Math.max(1, Math.ceil(Math.abs(sweep) / (Math.PI / 2))), d = sweep / n, k = 4 / 3 * Math.tan(d / 4);
    var t = a1 * rad, sx = x + r * Math.cos(t), sy = y + r * Math.sin(t);
    if (this.gs.cp) this.lineTo(sx, sy); else this.moveTo(sx, sy);
    for (var i = 0; i < n; i++) {
      var t0 = t + i * d, t1 = t0 + d;
      var c0 = Math.cos(t0), s0 = Math.sin(t0), c1 = Math.cos(t1), s1 = Math.sin(t1);
      this.curveTo(x + r * (c0 - k * s0), y + r * (s0 + k * c0), x + r * (c1 + k * s1), y + r * (s1 - k * c1), x + r * c1, y + r * s1);
    }
  };
  PS.prototype.gsave = function () { var g = this.gs; this.gstack.push(g); this.gs = { ctm: g.ctm.slice(), path: g.path.slice(), cp: g.cp, sp: g.sp, fill: g.fill, stroke: g.stroke, lw: g.lw, cap: g.cap, join: g.join, ml: g.ml, dash: g.dash, rule: g.rule }; this.ops.push('q'); };
  PS.prototype.grestore = function () { if (!this.gstack.length) return; this.gs = this.gstack.pop(); this.ops.push('Q'); };
  PS.prototype.setColor = function (cs, c, which) { var col = { cs: cs, c: c }; if (which !== 'stroke') this.gs.fill = col; if (which !== 'fill') this.gs.stroke = col; };

  // ---- PostScript values -> PDF syntax ----
  PS.prototype.toPdf = function (v) {
    var self = this;
    if (typeof v === 'number') return fmt(v);
    if (typeof v === 'boolean') return v ? 'true' : 'false';
    if (v === null || v === undefined) return 'null';
    if (v instanceof PSName) return pdfName(v.v);
    if (v instanceof PSStr) return hexEsc(v.b);
    if (v instanceof PSArr) { if (v.x) return 'null'; return '[' + v.a.map(function (x) { return self.toPdf(x); }).join(' ') + ']'; }
    if (v instanceof PSDict) {
      if (v.m.has('DataSource')) return this.streamFromDict(v, null);
      var parts = [];
      v.m.forEach(function (val, k) { parts.push(pdfName(k) + ' ' + (k === 'ColorSpace' ? self.csPdf(val) : (k === 'Function' || k === 'Functions' ? self.fnPdf(val, 1, 0) : self.toPdf(val)))); });
      return '<< ' + parts.join(' ') + ' >>';
    }
    return 'null';
  };
  PS.prototype.dataOf = function (src) {
    if (src instanceof PSStr) return src.b;
    if (src instanceof PSFilter || src instanceof PSFile) { var r = this.capture(src); if (r.filters.length) this.unsup('filtered data'); return r.raw; }
    if (src instanceof PSArr && !src.x) { this.unsup('array data'); }
    this.unsup('data source');
  };
  PS.prototype.streamFromDict = function (d, extra) {
    var self = this, parts = [], data = this.dataOf(d.m.get('DataSource'));
    d.m.forEach(function (val, k) {
      if (k === 'DataSource') return;
      parts.push(pdfName(k) + ' ' + (k === 'ColorSpace' ? self.csPdf(val) : (k === 'Function' || k === 'Functions' ? self.fnPdf(val, 1, 0) : self.toPdf(val))));
    });
    return this.pdf.add('<< ' + parts.join(' ') + (extra || '') + ' >>', data) + ' 0 R';
  };
  var CALC = { abs: 1, add: 1, atan: 1, ceiling: 1, cos: 1, cvi: 1, cvr: 1, div: 1, exp: 1, floor: 1, idiv: 1, ln: 1, log: 1, mod: 1, mul: 1, neg: 1, round: 1, sin: 1, sqrt: 1, sub: 1, truncate: 1, and: 1, bitshift: 1, eq: 1, ge: 1, gt: 1, le: 1, lt: 1, ne: 1, not: 1, or: 1, xor: 1, 'if': 1, ifelse: 1, copy: 1, dup: 1, exch: 1, index: 1, pop: 1, roll: 1, 'true': 1, 'false': 1 };
  PS.prototype.calcText = function (p) {
    var self = this, out = [];
    for (var i = 0; i < p.a.length; i++) {
      var e = p.a[i];
      if (typeof e === 'number') out.push(fmt(e));
      else if (typeof e === 'boolean') out.push(e ? 'true' : 'false');
      else if (e instanceof PSArr && e.x) { var t = self.calcText(e); if (t == null) return null; out.push(t); }
      else if (e instanceof PSName && e.x && CALC[e.v]) out.push(e.v);
      else if (e instanceof PSOp && CALC[e.name]) out.push(e.name);
      else return null;
    }
    return '{' + out.join(' ') + '}';
  };
  // function (dict, array of dicts, or PostScript procedure) -> PDF
  PS.prototype.fnPdf = function (f, nIn, nOut) {
    var self = this;
    if (f instanceof PSArr && !f.x) return '[' + f.a.map(function (x) { return self.fnPdf(x, nIn, nOut); }).join(' ') + ']';
    if (f instanceof PSDict) {
      if (f.m.has('DataSource')) return this.streamFromDict(f, null);
      return this.toPdf(f);
    }
    if (f instanceof PSArr && f.x) {
      var dom = []; for (var i = 0; i < nIn; i++) dom.push('0 1');
      if (!nOut) { try { nOut = this.call(f, new Array(nIn).fill(1)).length; } catch (e) { nOut = 1; } }
      var rng = []; for (var j = 0; j < nOut; j++) rng.push('0 1');
      var txt = this.calcText(f);
      if (txt) { var u = new Uint8Array(txt.length); for (var q = 0; q < txt.length; q++) u[q] = txt.charCodeAt(q) & 255; return this.pdf.add('<< /FunctionType 4 /Domain [' + dom.join(' ') + '] /Range [' + rng.join(' ') + '] >>', u) + ' 0 R'; }
      // sample the procedure
      var steps = nIn === 1 ? 256 : (nIn === 2 ? 17 : 5), total = Math.pow(steps, nIn), data = new Uint8Array(total * nOut);
      for (var s = 0; s < total; s++) {
        var args = [], rem = s; for (var d = 0; d < nIn; d++) { args.push((rem % steps) / (steps - 1)); rem = Math.floor(rem / steps); }
        var res; try { res = this.call(f, args, nOut); } catch (e2) { res = []; }
        for (var o = 0; o < nOut; o++) data[s * nOut + o] = Math.max(0, Math.min(255, Math.round((typeof res[o] === 'number' ? res[o] : 0) * 255)));
      }
      var size = []; for (var z = 0; z < nIn; z++) size.push(steps);
      return this.pdf.add('<< /FunctionType 0 /Domain [' + dom.join(' ') + '] /Range [' + rng.join(' ') + '] /Size [' + size.join(' ') + '] /BitsPerSample 8 >>', data) + ' 0 R';
    }
    return 'null';
  };
  PS.prototype.csInfo = function (v) { // -> { pdf: string, n: int, dev: 'DeviceGray'|... or null }
    if (v instanceof PSName || v instanceof PSStr) {
      var nm = this.key(v);
      if (/^(DeviceGray|CalGray|CIEBasedA)$/.test(nm)) return { pdf: '/DeviceGray', n: 1, dev: 'DeviceGray' };
      if (/^(DeviceRGB|CalRGB|CIEBasedABC|CIEBasedDEF)$/.test(nm)) return { pdf: '/DeviceRGB', n: 3, dev: 'DeviceRGB' };
      if (/^(DeviceCMYK|CIEBasedDEFG)$/.test(nm)) return { pdf: '/DeviceCMYK', n: 4, dev: 'DeviceCMYK' };
      var r = this.resources.CSA && this.resources.CSA.get(nm); if (r) return this.csInfo(r);
      this.unsup('color space ' + nm);
    }
    if (v instanceof PSArr) {
      if (!v.a.length) this.unsup('color space');
      var fam = this.key(v.a[0]);
      if (/^(DeviceGray|DeviceRGB|DeviceCMYK|CalGray|CalRGB|CIEBased)/.test(fam)) return this.csInfo(v.a[0]);
      if (fam === 'Separation') {
        var alt = this.csInfo(v.a[2]);
        return { pdf: '[/Separation ' + pdfName(this.key(v.a[1])) + ' ' + alt.pdf + ' ' + this.fnPdf(v.a[3], 1, alt.n) + ']', n: 1, dev: null };
      }
      if (fam === 'DeviceN') {
        var names = v.a[1].a, alt2 = this.csInfo(v.a[2]), self = this;
        return { pdf: '[/DeviceN [' + names.map(function (x) { return pdfName(self.key(x)); }).join(' ') + '] ' + alt2.pdf + ' ' + this.fnPdf(v.a[3], names.length, alt2.n) + ']', n: names.length, dev: null };
      }
      if (fam === 'Indexed') {
        var base = this.csInfo(v.a[1]), hi = v.a[2], lk = v.a[3], bytes;
        if (lk instanceof PSStr) bytes = lk.b;
        else { bytes = new Uint8Array((hi + 1) * base.n); for (var i = 0; i <= hi; i++) { var rr = this.call(lk, [i], base.n); for (var c = 0; c < base.n; c++) bytes[i * base.n + c] = Math.round(Math.max(0, Math.min(1, rr[c] || 0)) * 255); } }
        return { pdf: '[/Indexed ' + base.pdf + ' ' + hi + ' ' + hexEsc(bytes) + ']', n: 1, dev: null };
      }
      this.unsup('color space ' + fam);
    }
    if (v instanceof PSDict && v.m.has('Name')) return this.sepCsd(v).info;
    this.unsup('color space');
  };
  PS.prototype.csPdf = function (v) { return this.csInfo(v).pdf; };
  PS.prototype.setColorSpace = function (v) {
    var inf = this.csInfo(v), cs = inf.dev || { pdf: inf.pdf, n: inf.n };
    var init = inf.dev === 'DeviceCMYK' ? [0, 0, 0, 1] : (inf.dev === 'DeviceRGB' ? [0, 0, 0] : (inf.dev === 'DeviceGray' ? [0] : new Array(inf.n).fill(/Indexed/.test(inf.pdf.slice(0, 9)) ? 0 : 1)));
    this.setColor(cs, init);
  };
  // AGM "CSD" color space dictionaries for spot colors
  PS.prototype.sepCsd = function (d) {
    var name = this.key(d.m.get('Name') || new PSStr(new Uint8Array(0)));
    var comps = d.m.get('Components'), method = this.key(d.m.get('TintMethod') || new PSName('Subtractive'));
    var altV = d.m.get('MappedCSA') || d.m.get('CSA') || new PSName('DeviceCMYK');
    var alt = this.csInfo(altV);
    if (!comps || !(comps instanceof PSArr)) this.unsup('spot color');
    var c1 = comps.a.map(function (x) { return typeof x === 'number' ? x : 0; }).slice(0, alt.n), c0;
    if (method === 'Subtractive') c0 = c1.map(function () { return 0; });
    else c0 = c1.map(function () { return 1; });
    if (name === 'All') return { info: { pdf: '[/Separation /All ' + alt.pdf + ' << /FunctionType 2 /Domain [0 1] /C0 [' + c0.map(fmt).join(' ') + '] /C1 [' + c1.map(fmt).join(' ') + '] /N 1 >>]', n: 1, dev: null } };
    return { info: { pdf: '[/Separation ' + pdfName(name) + ' ' + alt.pdf + ' << /FunctionType 2 /Domain [0 1] /C0 [' + c0.map(fmt).join(' ') + '] /C1 [' + c1.map(fmt).join(' ') + '] /N 1 >>]', n: 1, dev: null } };
  };

  // ---- reading data that follows an operator in the file ----
  PS.prototype.capture = function (src) {
    var chain = [], x = src;
    while (x instanceof PSFilter) { chain.unshift(x); x = x.src; }
    if (!(x instanceof PSFile)) this.unsup('data source');
    var b = this.b, p = this.p, first = chain[0], end, raw, names = [], parms = [];
    if (!first) this.unsup('raw file data');
    var nm = first.name;
    if (nm === 'ASCII85Decode') { while (p < this.end && WS[b[p]]) p++; end = p; while (end < this.end - 1 && !(b[end] === 126 && b[end + 1] === 62)) end++; raw = b.subarray(p, end + 2); this.p = end + 2; }
    else if (nm === 'ASCIIHexDecode') { end = p; while (end < this.end && b[end] !== 62) end++; raw = b.subarray(p, end + 1); this.p = end + 1; }
    else if (nm === 'RunLengthDecode') { end = p; while (end < this.end) { var n = b[end++]; if (n === 128) break; end += n < 128 ? n + 1 : 1; } raw = b.subarray(p, end); this.p = end; }
    else if (nm === 'SubFileDecode') {
      var cnt = first.parms.count, eods = first.parms.eod;
      if (eods && eods.length) { var s = latin1(eods); end = latin1(b, p, Math.min(this.end, p + 50000000)).indexOf(s); if (end < 0) this.unsup('subfile'); end += p; raw = b.subarray(p, end); this.p = end + s.length; }
      else if (cnt > 0) { raw = b.subarray(p, p + cnt); this.p = p + cnt; }
      else this.unsup('subfile');
      chain.shift();
    }
    else if (nm === 'DCTDecode') { end = p + 2; while (end < this.end - 1 && !(b[end] === 255 && b[end + 1] === 217)) end++; raw = b.subarray(p, end + 2); this.p = end + 2; }
    else if (/^(FlateDecode|LZWDecode|CCITTFaxDecode)$/.test(nm)) {
      var txt = latin1(b, p, Math.min(this.end, p + 60000000)), k = txt.indexOf('%%EndData');
      if (k < 0) this.unsup('binary ' + nm);
      end = p + k; while (end > p && (b[end - 1] === 10 || b[end - 1] === 13)) end--;
      raw = b.subarray(p, end); this.p = p + k;
    }
    else this.unsup('filter ' + nm);
    chain.forEach(function (f) { names.push(f.name); parms.push(f.pdfParms || 'null'); });
    return { raw: raw, filters: names, parms: parms };
  };
  PS.prototype.readFileBytes = function (src, n, hex) {
    if (src instanceof PSFile) {
      var b = this.b;
      if (hex) {
        var out = new Uint8Array(n), k = 0, hi = -1;
        while (k < n && this.p < this.end) {
          var c = b[this.p++], v = c >= 48 && c <= 57 ? c - 48 : (c >= 65 && c <= 70 ? c - 55 : (c >= 97 && c <= 102 ? c - 87 : -1));
          if (v < 0) continue; if (hi < 0) hi = v; else { out[k++] = hi * 16 + v; hi = -1; }
        }
        return out.subarray(0, k);
      }
      if (!src.started) { src.started = true; }
      var r = b.subarray(this.p, Math.min(this.end, this.p + n)); this.p += r.length; return r;
    }
    if (src instanceof PSFilter) {
      if (!src.buf) {
        var inner = src.src, all;
        if (inner instanceof PSFile) { var cap = this.capture(src); all = this.decodeSimple(cap.raw, cap.filters); }
        else all = this.decodeSimple(this.readFileBytes(inner, 1e9, false), [src.name]);
        src.buf = all; src.pos = 0;
      }
      var r2 = src.buf.subarray(src.pos, src.pos + n); src.pos += r2.length; return r2;
    }
    this.unsup('read');
  };
  PS.prototype.decodeSimple = function (raw, filters) {
    var d = raw;
    filters.forEach(function (f) {
      if (f === 'ASCII85Decode') { var e = d.length; for (var i = 0; i < d.length - 1; i++) if (d[i] === 126 && d[i + 1] === 62) { e = i; break; } d = a85(d, 0, e); }
      else if (f === 'ASCIIHexDecode') d = ahx(d, 0, d.length);
      else if (f === 'RunLengthDecode') { var out = [], p = 0; while (p < d.length) { var n = d[p++]; if (n === 128) break; if (n < 128) { for (var k = 0; k <= n; k++) out.push(d[p++]); } else { var v = d[p++]; for (var j = 0; j < 257 - n; j++) out.push(v); } } d = new Uint8Array(out); }
      else throw new Unsupported('filter ' + f);
    });
    return d;
  };

  // ---- images ----
  PS.prototype.doImage = function (o) {
    // o: { w, h, bpc, cs (pdf string), n, matrix, src, decode, mask, polarity, interp }
    var g = this.gs, inv = minv(o.matrix); if (!inv) return;
    var rowBytes = Math.ceil(o.w * o.n * o.bpc / 8), need = rowBytes * o.h, data, filters = [], parms = [];
    var src = o.src;
    if (src instanceof PSFilter) { var cap = this.capture(src); data = cap.raw; filters = cap.filters; parms = cap.parms; }
    else if (src instanceof PSFile) { data = this.readFileBytes(src, need, false); }
    else if (src instanceof PSStr) { data = src.b; if (data.length < need && data.length) { var rep = new Uint8Array(need); for (var i = 0; i < need; i++) rep[i] = data[i % data.length]; data = rep; } }
    else if (src instanceof PSArr && src.x) {
      var chunks = [], got = 0, guard = 0;
      while (got < need && guard++ < 2000000) { var r = this.call(src, []); var s = r[r.length - 1]; if (!(s instanceof PSStr) || !s.b.length) break; chunks.push(s.b.slice()); got += s.b.length; }
      data = new Uint8Array(got); var q = 0; chunks.forEach(function (c) { data.set(c, q); q += c.length; });
    } else this.unsup('image data');
    var f = filters.length ? ' /Filter [' + filters.map(pdfName).join(' ') + ']' + (parms.some(function (x) { return x !== 'null'; }) ? ' /DecodeParms [' + parms.join(' ') + ']' : '') : '';
    var dict = '<< /Type /XObject /Subtype /Image /Width ' + o.w + ' /Height ' + o.h + (o.mask ? ' /ImageMask true' + (o.polarity ? ' /Decode [1 0]' : '') : ' /ColorSpace ' + o.cs + ' /BitsPerComponent ' + o.bpc + (o.decode ? ' /Decode [' + o.decode.map(fmt).join(' ') + ']' : '')) + (o.interp ? ' /Interpolate true' : '') + f + ' >>';
    var id = this.pdf.add(dict, data);
    var nm = '/Im' + this.addRes('xo', id + ' 0 R');
    var M = mmul(mmul([o.w, 0, 0, -o.h, 0, o.h], inv), g.ctm);
    this.ops.push('q ' + (o.mask ? this.colorOp(g.fill, false) + ' ' : '') + M.map(fmt).join(' ') + ' cm ' + nm + ' Do Q'); this.paints++;
  };
  PS.prototype.imageDict = function (d, mask) {
    var gv = function (k, def) { return d.m.has(k) ? d.m.get(k) : def; };
    var csv = gv('ColorSpace', null), cs = null, n = 1;
    if (!mask) {
      if (csv) { var inf = this.csInfo(csv); cs = inf.pdf; n = inf.n; }
      else if (d.m.has('CSA')) { var inf2 = this.csInfo(d.m.get('CSA')); cs = inf2.pdf; n = inf2.n; }
      else { var cur = this.gs.fill.cs; if (typeof cur === 'string') { cs = '/' + cur; n = this.nComps(cur); } else { cs = cur.pdf; n = cur.n; } }
    }
    if (gv('MultipleDataSources', false)) this.unsup('multiple data sources');
    var dec = gv('Decode', null);
    this.doImage({ w: gv('Width', 0), h: gv('Height', 0), bpc: mask ? 1 : gv('BitsPerComponent', 8), cs: cs, n: mask ? 1 : n, matrix: gv('ImageMatrix', new PSArr([1, 0, 0, 1, 0, 0])).a, src: gv('DataSource', null), decode: (!mask && dec) ? dec.a : null, mask: mask, polarity: mask && dec && dec.a[0] === 1, interp: gv('Interpolate', false) });
  };

  PS.prototype.initOps = function () {
    var S = this, d = function (n, f) { S.def(n, f); };
    var TYPE = function (v) {
      if (typeof v === 'number') return Number.isInteger(v) ? 'integertype' : 'realtype';
      if (typeof v === 'boolean') return 'booleantype';
      if (v instanceof PSName) return 'nametype'; if (v instanceof PSStr) return 'stringtype'; if (v instanceof PSArr) return 'arraytype';
      if (v instanceof PSDict) return 'dicttype'; if (v instanceof PSOp) return 'operatortype'; if (v instanceof PSFile || v instanceof PSFilter) return 'filetype';
      if (v === MARK) return 'marktype'; if (v === null) return 'nulltype'; if (v instanceof PSSave) return 'savetype'; return 'nulltype';
    };
    var EQ = function (a, b) {
      if ((a instanceof PSName || a instanceof PSStr) && (b instanceof PSName || b instanceof PSStr)) return S.key(a) === S.key(b);
      return a === b;
    };
    // stack
    d('pop', function () { this.pop(); });
    d('exch', function () { var b = this.pop(), a = this.pop(); this.push(b); this.push(a); });
    d('dup', function () { var a = this.pop(); this.push(a); this.push(a); });
    d('copy', function () {
      var t = this.pop();
      if (typeof t === 'number') { var n = t, l = this.os.length; if (n > l) this.err('stackunderflow'); for (var i = l - n; i < l; i++) this.push(this.os[i]); return; }
      var s = this.pop();
      if (t instanceof PSArr) { for (var j = 0; j < s.a.length; j++) t.a[j] = s.a[j]; this.push(new PSArr(t.a.slice(0, s.a.length), t.x)); }
      else if (t instanceof PSDict) { s.m.forEach(function (v, k) { t.m.set(k, v); }); this.push(t); }
      else if (t instanceof PSStr) { t.b.set(s.b.subarray(0, t.b.length)); this.push(new PSStr(t.b.subarray(0, s.b.length))); }
      else this.push(t);
    });
    d('index', function () { var n = this.num(); this.push(this.os[this.os.length - 1 - n]); });
    d('roll', function () { var j = this.num(), n = this.num(); if (n <= 0) return; var a = this.os.splice(this.os.length - n, n); j = ((j % n) + n) % n; for (var i = 0; i < n; i++) this.push(a[(i - j + n) % n]); });
    d('clear', function () { this.os.length = 0; });
    d('count', function () { this.push(this.os.length); });
    d('mark', function () { this.push(MARK); }); this.alias('[', 'mark'); this.alias('<<', 'mark');
    d('cleartomark', function () { while (this.os.length && this.os.pop() !== MARK) {} });
    d('counttomark', function () { for (var i = this.os.length - 1; i >= 0; i--) if (this.os[i] === MARK) { this.push(this.os.length - 1 - i); return; } this.err('unmatchedmark'); });
    d(']', function () { var a = []; for (;;) { var v = this.pop(); if (v === MARK) break; a.unshift(v); } this.push(new PSArr(a, false)); });
    d('>>', function () { var a = []; for (;;) { var v = this.pop(); if (v === MARK) break; a.unshift(v); } var dd = new PSDict(); for (var i = 0; i + 1 < a.length; i += 2) dd.m.set(this.key(a[i]), a[i + 1]); this.push(dd); });
    // math
    d('add', function () { var b = this.num(), a = this.num(); this.push(a + b); });
    d('sub', function () { var b = this.num(), a = this.num(); this.push(a - b); });
    d('mul', function () { var b = this.num(), a = this.num(); this.push(a * b); });
    d('div', function () { var b = this.num(), a = this.num(); this.push(b ? a / b : 0); });
    d('idiv', function () { var b = this.num(), a = this.num(); this.push(b ? Math.trunc(a / b) : 0); });
    d('mod', function () { var b = this.num(), a = this.num(); this.push(b ? a % b : 0); });
    d('neg', function () { this.push(-this.num()); });
    d('abs', function () { this.push(Math.abs(this.num())); });
    d('ceiling', function () { this.push(Math.ceil(this.num())); });
    d('floor', function () { this.push(Math.floor(this.num())); });
    d('round', function () { this.push(Math.round(this.num())); });
    d('truncate', function () { this.push(Math.trunc(this.num())); });
    d('sqrt', function () { this.push(Math.sqrt(Math.max(0, this.num()))); });
    d('atan', function () { var b = this.num(), a = this.num(); var r = Math.atan2(a, b) * 180 / Math.PI; this.push(r < 0 ? r + 360 : r); });
    d('cos', function () { this.push(Math.cos(this.num() * Math.PI / 180)); });
    d('sin', function () { this.push(Math.sin(this.num() * Math.PI / 180)); });
    d('exp', function () { var b = this.num(), a = this.num(); this.push(Math.pow(a, b)); });
    d('ln', function () { this.push(Math.log(this.num())); });
    d('log', function () { this.push(Math.log(this.num()) / Math.LN10); });
    d('cvi', function () { var v = this.pop(); if (v instanceof PSStr) v = parseFloat(latin1(v.b)) || 0; this.push(Math.trunc(v)); });
    d('cvr', function () { var v = this.pop(); if (v instanceof PSStr) v = parseFloat(latin1(v.b)) || 0; this.push(+v); });
    d('rand', function () { this.push(Math.floor(Math.random() * 2147483647)); });
    d('srand', function () { this.pop(); });
    d('bitshift', function () { var s = this.num(), a = this.num(); this.push(s >= 0 ? a << s : a >> -s); });
    // relational / boolean
    d('eq', function () { var b = this.pop(), a = this.pop(); this.push(EQ(a, b)); });
    d('ne', function () { var b = this.pop(), a = this.pop(); this.push(!EQ(a, b)); });
    var cmp = function (f) { return function () { var b = this.pop(), a = this.pop(); if (a instanceof PSStr) a = latin1(a.b); if (b instanceof PSStr) b = latin1(b.b); this.push(f(a, b)); }; };
    d('gt', cmp(function (a, b) { return a > b; })); d('ge', cmp(function (a, b) { return a >= b; })); d('lt', cmp(function (a, b) { return a < b; })); d('le', cmp(function (a, b) { return a <= b; }));
    d('and', function () { var b = this.pop(), a = this.pop(); this.push(typeof a === 'boolean' ? (a && b) : (a & b)); });
    d('or', function () { var b = this.pop(), a = this.pop(); this.push(typeof a === 'boolean' ? (a || b) : (a | b)); });
    d('xor', function () { var b = this.pop(), a = this.pop(); this.push(typeof a === 'boolean' ? (a !== b) : (a ^ b)); });
    d('not', function () { var a = this.pop(); this.push(typeof a === 'boolean' ? !a : ~a); });
    d('true', function () { this.push(true); }); d('false', function () { this.push(false); }); d('null', function () { this.push(null); });
    // control
    d('exec', function () { this.execObj(this.pop()); });
    d('if', function () { var p = this.pop(), c = this.pop(); if (c === true) this.execObj(p); });
    d('ifelse', function () { var p2 = this.pop(), p1 = this.pop(), c = this.pop(); this.execObj(c === true ? p1 : p2); });
    d('for', function () {
      var p = this.pop(), lim = this.num(), inc = this.num(), v = this.num(), n = 0;
      try { while ((inc > 0 ? v <= lim + 1e-9 : v >= lim - 1e-9) && n++ < 1000000) { this.push(v); this.execObj(p); v += inc; } } catch (e) { if (!(e instanceof ExitSig)) throw e; }
    });
    d('repeat', function () { var p = this.pop(), n = this.num(); try { for (var i = 0; i < n; i++) this.execObj(p); } catch (e) { if (!(e instanceof ExitSig)) throw e; } });
    d('loop', function () { var p = this.pop(), n = 0; try { while (n++ < 1000000) this.execObj(p); } catch (e) { if (!(e instanceof ExitSig)) throw e; } });
    d('exit', function () { throw new ExitSig(); });
    d('stop', function () { throw new StopSig(); });
    d('stopped', function () { var p = this.pop(), depth = this.gstack.length; try { this.execObj(p); this.push(false); } catch (e) { if (e instanceof Unsupported) throw e; while (this.gstack.length > depth) this.grestore(); this.push(true); } });
    d('forall', function () {
      var p = this.pop(), c = this.pop();
      try {
        if (c instanceof PSArr) for (var i = 0; i < c.a.length; i++) { this.push(c.a[i]); this.execObj(p); }
        else if (c instanceof PSStr) for (var j = 0; j < c.b.length; j++) { this.push(c.b[j]); this.execObj(p); }
        else if (c instanceof PSDict) { var ents = Array.from(c.m.entries()); for (var k = 0; k < ents.length; k++) { this.push(new PSName(ents[k][0], false)); this.push(ents[k][1]); this.execObj(p); } }
      } catch (e) { if (!(e instanceof ExitSig)) throw e; }
    });
    d('quit', function () { throw new StopSig(); });
    d('countexecstack', function () { this.push(1); });
    // types / conversion
    d('type', function () { this.push(new PSName(TYPE(this.pop()), true)); });
    d('cvx', function () { var v = this.pop(); if (v instanceof PSArr) v = new PSArr(v.a, true); else if (v instanceof PSName) v = new PSName(v.v, true); else if (v instanceof PSStr) { var it = new PS(v.b, 0, v.b.length, ''); v = it.readProc(); } this.push(v); });
    d('cvlit', function () { var v = this.pop(); if (v instanceof PSArr) v = new PSArr(v.a, false); else if (v instanceof PSName) v = new PSName(v.v, false); this.push(v); });
    d('xcheck', function () { var v = this.pop(); this.push(!!((v instanceof PSArr || v instanceof PSName) && v.x) || v instanceof PSOp); });
    d('cvn', function () { var v = this.pop(); this.push(new PSName(this.key(v), false)); });
    d('cvs', function () { var buf = this.pop(), v = this.pop(); var s = v instanceof PSName ? v.v : (v instanceof PSStr ? latin1(v.b) : (typeof v === 'number' || typeof v === 'boolean' ? String(v) : '--nostringval--')); var u = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) u[i] = s.charCodeAt(i) & 255; if (buf instanceof PSStr) buf.b.set(u.subarray(0, buf.b.length)); this.push(new PSStr(u)); });
    d('cvrs', function () { this.pop(); var r = this.num(), n = this.num(); var s = Math.trunc(n).toString(r).toUpperCase(), u = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) u[i] = s.charCodeAt(i); this.push(new PSStr(u)); });
    ['bind', 'readonly', 'executeonly', 'noaccess'].forEach(function (n) { d(n, function () {}); });
    d('rcheck', function () { this.pop(); this.push(true); }); d('wcheck', function () { this.pop(); this.push(true); });
    // dictionaries
    d('dict', function () { this.num(); this.push(new PSDict()); });
    d('begin', function () { var v = this.pop(); if (!(v instanceof PSDict)) this.err('typecheck begin'); this.ds.push(v); });
    d('end', function () { if (this.ds.length > 2) this.ds.pop(); });
    d('def', function () { var v = this.pop(), k = this.pop(); this.ds[this.ds.length - 1].m.set(this.key(k), v); });
    d('load', function () { var k = this.key(this.pop()), v = this.lookup(k); if (v === undefined) this.err('undefined ' + k); this.push(v); });
    d('store', function () { var v = this.pop(), k = this.key(this.pop()); for (var i = this.ds.length - 1; i >= 0; i--) if (this.ds[i].m.has(k)) { this.ds[i].m.set(k, v); return; } this.ds[this.ds.length - 1].m.set(k, v); });
    d('known', function () { var k = this.key(this.pop()), dd = this.pop(); this.push(dd instanceof PSDict && dd.m.has(k)); });
    d('where', function () { var k = this.key(this.pop()); for (var i = this.ds.length - 1; i >= 0; i--) if (this.ds[i].m.has(k)) { this.push(this.ds[i]); this.push(true); return; } this.push(false); });
    d('undef', function () { var k = this.key(this.pop()), dd = this.pop(); if (dd instanceof PSDict) dd.m.delete(k); });
    d('currentdict', function () { this.push(this.ds[this.ds.length - 1]); });
    d('countdictstack', function () { this.push(this.ds.length); });
    var userdict = this.user, sysd = this.sys, globald = new PSDict(), statusd = new PSDict(), errd = new PSDict();
    d('userdict', function () { this.push(userdict); }); d('systemdict', function () { this.push(sysd); }); d('globaldict', function () { this.push(globald); });
    d('statusdict', function () { this.push(statusd); }); d('errordict', function () { this.push(errd); }); d('$error', function () { this.push(errd); });
    d('maxlength', function () { var v = this.pop(); this.push(v instanceof PSDict ? v.m.size + 50 : 0); });
    d('length', function () { var v = this.pop(); this.push(v instanceof PSArr ? v.a.length : (v instanceof PSStr ? v.b.length : (v instanceof PSDict ? v.m.size : (v instanceof PSName ? v.v.length : 0)))); });
    d('get', function () {
      var k = this.pop(), c = this.pop();
      if (c instanceof PSArr) { this.push(c.a[k]); return; }
      if (c instanceof PSStr) { this.push(c.b[k]); return; }
      if (c instanceof PSDict) { var kk = this.key(k); if (!c.m.has(kk)) this.err('undefined get ' + kk); this.push(c.m.get(kk)); return; }
      this.err('typecheck get');
    });
    d('put', function () { var v = this.pop(), k = this.pop(), c = this.pop(); if (c instanceof PSArr) c.a[k] = v; else if (c instanceof PSStr) c.b[k] = v; else if (c instanceof PSDict) c.m.set(this.key(k), v); });
    d('array', function () { var n = this.num(); this.push(new PSArr(new Array(n).fill(null), false)); });
    d('packedarray', function () { var n = this.num(), a = []; for (var i = 0; i < n; i++) a.unshift(this.pop()); this.push(new PSArr(a, false)); });
    d('aload', function () { var a = this.pop(); a.a.forEach(function (v) { this.push(v); }, this); this.push(a); });
    d('astore', function () { var a = this.pop(); for (var i = a.a.length - 1; i >= 0; i--) a.a[i] = this.pop(); this.push(a); });
    d('getinterval', function () { var n = this.num(), i = this.num(), c = this.pop(); if (c instanceof PSArr) this.push(new PSArr(c.a.slice(i, i + n), c.x)); else this.push(new PSStr(c.b.subarray(i, i + n))); });
    d('putinterval', function () { var s = this.pop(), i = this.num(), c = this.pop(); if (c instanceof PSArr) for (var k = 0; k < s.a.length; k++) c.a[i + k] = s.a[k]; else if (c instanceof PSStr) c.b.set(s.b, i); });
    d('string', function () { this.push(new PSStr(new Uint8Array(this.num()))); });
    d('search', function () { var sk = latin1(this.pop().b), sv = this.pop(), s = latin1(sv.b), i = s.indexOf(sk); if (i < 0) { this.push(sv); this.push(false); return; } this.push(new PSStr(sv.b.subarray(i + sk.length))); this.push(new PSStr(sv.b.subarray(i, i + sk.length))); this.push(new PSStr(sv.b.subarray(0, i))); this.push(true); });
    d('anchorsearch', function () { var sk = latin1(this.pop().b), sv = this.pop(), s = latin1(sv.b); if (s.indexOf(sk) !== 0) { this.push(sv); this.push(false); return; } this.push(new PSStr(sv.b.subarray(sk.length))); this.push(new PSStr(sv.b.subarray(0, sk.length))); this.push(true); });
    // environment
    d('version', function () { this.push(new PSStr(new Uint8Array([51, 48, 49, 48]))); });
    d('languagelevel', function () { this.push(3); });
    d('product', function () { this.push(new PSStr(new Uint8Array([80, 83]))); });
    d('revision', function () { this.push(1); });
    ['setglobal', 'setpacking', 'setsmoothness', 'setflat', 'setstrokeadjust', 'setoverprint', 'setblackgeneration', 'setundercolorremoval', 'settransfer', 'setcolortransfer', 'setcolorrendering', 'setpagedevice', 'setuserparams', 'setsystemparams', 'sethalftone', 'setobjectformat', 'srand', 'print', '=', '==', 'setvmthreshold', 'setcachelimit', 'setucacheparams'].forEach(function (n) { d(n, function () { this.pop(); }); });
    d('setscreen', function () { this.pop(); this.pop(); this.pop(); });
    d('setcolorscreen', function () { for (var i = 0; i < 12; i++) this.pop(); });
    ['currentglobal', 'currentpacking', 'currentoverprint', 'currentstrokeadjust'].forEach(function (n) { d(n, function () { this.push(false); }); });
    d('currentflat', function () { this.push(1); }); d('currentsmoothness', function () { this.push(0.02); });
    d('currentscreen', function () { this.push(60); this.push(45); this.push(new PSArr([], true)); });
    d('currenthalftone', function () { this.push(new PSDict()); }); d('currenttransfer', function () { this.push(new PSArr([], true)); });
    d('currentblackgeneration', function () { this.push(new PSArr([], true)); }); d('currentundercolorremoval', function () { this.push(new PSArr([], true)); });
    d('currentpagedevice', function () { this.push(new PSDict()); }); d('currentuserparams', function () { this.push(new PSDict()); }); d('currentsystemparams', function () { this.push(new PSDict()); });
    d('vmstatus', function () { this.push(0); this.push(0); this.push(10000000); });
    d('realtime', function () { this.push(0); }); d('usertime', function () { this.push(0); });
    d('findcolorrendering', function () { this.pop(); this.push(new PSName('Default', false)); this.push(false); });
    ['flush', 'showpage', 'copypage', 'erasepage', 'initgraphics', 'flushfile', 'closefile', 'resetfile'].forEach(function (n) { d(n, function () { if (n === 'flushfile' || n === 'closefile' || n === 'resetfile') this.pop(); }); });
    // resources
    d('defineresource', function () { var cat = this.key(this.pop()), v = this.pop(), k = this.key(this.pop()); (this.resources[cat] = this.resources[cat] || new Map()).set(k, v); this.push(v); });
    d('findresource', function () { var cat = this.key(this.pop()), k = this.key(this.pop()); var m = this.resources[cat]; if (m && m.has(k)) { this.push(m.get(k)); return; } if (cat === 'ProcSet' || cat === 'Font' || cat === 'CIDFont' || cat === 'Encoding') { this.push(new PSDict()); return; } this.err('undefinedresource ' + cat + ' ' + k); });
    d('resourcestatus', function () { var cat = this.key(this.pop()), k = this.key(this.pop()); var m = this.resources[cat]; if (m && m.has(k)) { this.push(0); this.push(0); this.push(true); } else this.push(false); });
    d('undefineresource', function () { var cat = this.key(this.pop()), k = this.key(this.pop()); if (this.resources[cat]) this.resources[cat].delete(k); });
    d('add_res', function () { var cat = this.key(this.pop()), v = this.pop(), k = this.key(this.pop()); (this.resources[cat] = this.resources[cat] || new Map()).set(k, v); });
    d('get_res', function () { var cat = this.key(this.pop()), k = this.pop(); if (!(k instanceof PSName || k instanceof PSStr)) { this.push(k); return; } var m = this.resources[cat]; if (m && m.has(this.key(k))) this.push(m.get(this.key(k))); else this.err('get_res ' + cat); });
    d('get_csa_by_name', function () { var k = this.pop(); if (k instanceof PSName || k instanceof PSStr) { var m = this.resources.CSA; this.push(m && m.has(this.key(k)) ? m.get(this.key(k)) : k); } else this.push(k); });
    d('clonedict', function () { var v = this.pop(), c = new PSDict(); if (v instanceof PSDict) v.m.forEach(function (x, k) { c.m.set(k, x); }); this.push(c); });
    d('clonearray', function () { var v = this.pop(); this.push(v instanceof PSArr ? new PSArr(v.a.slice(), v.x) : v); });
    // fonts and text: not supported (outline your text)
    ['findfont', 'scalefont', 'makefont', 'definefont', 'composefont', 'findencoding'].forEach(function (n) { d(n, function () { if (n !== 'findfont' && n !== 'findencoding') this.pop(); if (n === 'definefont' || n === 'composefont') this.pop(); if (n !== 'scalefont' && n !== 'makefont') this.pop(); this.push(new PSDict()); }); });
    d('setfont', function () { this.pop(); }); d('selectfont', function () { this.pop(); this.pop(); }); d('currentfont', function () { this.push(new PSDict()); });
    ['show', 'ashow', 'widthshow', 'awidthshow', 'kshow', 'xshow', 'yshow', 'xyshow', 'glyphshow', 'cshow', 'charpath', 'stringwidth'].forEach(function (n) { d(n, function () { this.unsup('live text'); }); });
    // files and filters
    d('currentfile', function () { this.push(new PSFile(this)); });
    d('filter', function () {
      var name = this.key(this.pop()), parms = {}, pdfParms = 'null';
      if (name === 'SubFileDecode') { var eod = this.pop(), cnt = this.num(); parms = { count: cnt, eod: eod instanceof PSStr ? eod.b : null }; }
      else if (this.os[this.os.length - 1] instanceof PSDict) { var pd = this.pop(); pdfParms = this.toPdf(pd); }
      var src = this.pop();
      if (src instanceof PSStr) { var it = new PS(src.b, 0, src.b.length, ''); src = new PSFile(it); src.str = true; }
      var f = new PSFilter(name, src, parms); f.pdfParms = pdfParms; this.push(f);
    });
    d('readstring', function () { var s = this.pop(), f = this.pop(); var r = this.readFileBytes(f, s.b.length, false); s.b.set(r); this.push(new PSStr(s.b.subarray(0, r.length))); this.push(r.length === s.b.length); });
    d('readhexstring', function () { var s = this.pop(), f = this.pop(); var r = this.readFileBytes(f, s.b.length, true); s.b.set(r); this.push(new PSStr(s.b.subarray(0, r.length))); this.push(r.length === s.b.length); });
    d('readline', function () { var s = this.pop(); this.pop(); var b = this.b, st = this.p; while (this.p < this.end && b[this.p] !== 10 && b[this.p] !== 13) this.p++; var line = b.subarray(st, this.p); if (b[this.p] === 13) this.p++; if (b[this.p] === 10) this.p++; s.b.set(line.subarray(0, s.b.length)); this.push(new PSStr(s.b.subarray(0, Math.min(line.length, s.b.length)))); this.push(true); });
    d('read', function () { var f = this.pop(); var r = this.readFileBytes(f, 1, false); if (r.length) { this.push(r[0]); this.push(true); } else this.push(false); });
    d('token', function () {
      var src = this.pop();
      if (src instanceof PSFile) { var it = src.it; var t = it.token(); if (t === EOF) { this.push(false); return; } this.push(t); this.push(true); return; }
      if (src instanceof PSStr) { var sub = new PS(src.b, 0, src.b.length, ''); var t2 = sub.token(); if (t2 === EOF) { this.push(false); return; } this.push(new PSStr(src.b.subarray(sub.p))); this.push(t2); this.push(true); return; }
      this.push(false);
    });
    d('bytesavailable', function () { this.pop(); this.push(-1); });
    // graphics state
    d('gsave', function () { this.gsave(); });
    d('grestore', function () { this.grestore(); });
    d('grestoreall', function () { while (this.gstack.length) this.grestore(); });
    d('save', function () { this.gsave(); this.push(new PSSave(this.gstack.length)); });
    d('restore', function () { var s = this.pop(); var depth = s instanceof PSSave ? s.depth : 1; while (this.gstack.length >= depth && this.gstack.length) this.grestore(); });
    d('setlinewidth', function () { this.gs.lw = this.num(); });
    d('setlinecap', function () { this.gs.cap = Math.round(this.num()) & 3; });
    d('setlinejoin', function () { this.gs.join = Math.round(this.num()) & 3; });
    d('setmiterlimit', function () { this.gs.ml = this.num(); });
    d('setdash', function () { var off = this.num(), a = this.pop(); this.gs.dash = [a instanceof PSArr ? a.a.filter(function (x) { return typeof x === 'number'; }) : [], off]; });
    d('currentlinewidth', function () { this.push(this.gs.lw); });
    d('currentlinecap', function () { this.push(this.gs.cap); }); d('currentlinejoin', function () { this.push(this.gs.join); }); d('currentmiterlimit', function () { this.push(this.gs.ml); });
    d('currentdash', function () { this.push(new PSArr(this.gs.dash[0].slice(), false)); this.push(this.gs.dash[1]); });
    // color
    d('setgray', function () { this.setColor('DeviceGray', [this.num()]); });
    d('setrgbcolor', function () { this.setColor('DeviceRGB', this.nums(3)); });
    d('setcmykcolor', function () { this.setColor('DeviceCMYK', this.nums(4)); });
    d('sethsbcolor', function () {
      var v = this.nums(3), h = v[0] * 6, s = v[1], br = v[2], i = Math.floor(h) % 6, f = h - Math.floor(h), p = br * (1 - s), q = br * (1 - s * f), t = br * (1 - s * (1 - f));
      var rgb = [[br, t, p], [q, br, p], [p, br, t], [p, q, br], [t, p, br], [br, p, q]][i]; this.setColor('DeviceRGB', rgb);
    });
    d('setcolorspace', function () { this.setColorSpace(this.pop()); });
    d('setcolor', function () {
      var top = this.os[this.os.length - 1];
      if (top instanceof PSDict) this.unsup('pattern');
      var cs = this.gs.fill.cs, n = this.nComps(cs); this.setColor(cs, this.nums(n));
    });
    d('setpattern', function () { this.unsup('pattern'); }); d('makepattern', function () { this.unsup('pattern'); });
    d('currentgray', function () { this.push(0); }); d('currentrgbcolor', function () { this.push(0); this.push(0); this.push(0); });
    d('currentcmykcolor', function () { var f = this.gs.fill; if (f.cs === 'DeviceCMYK') f.c.forEach(function (x) { this.push(x); }, this); else { this.push(0); this.push(0); this.push(0); this.push(1); } });
    d('currentcolorspace', function () { var cs = this.gs.fill.cs; this.push(new PSArr([new PSName(typeof cs === 'string' ? cs : 'DeviceGray', false)], false)); });
    d('currentcolor', function () { this.gs.fill.c.forEach(function (x) { this.push(x); }, this); });
    // matrices
    d('matrix', function () { this.push(new PSArr([1, 0, 0, 1, 0, 0], false)); });
    d('identmatrix', function () { var m = this.pop(); m.a = [1, 0, 0, 1, 0, 0]; this.push(m); });
    d('currentmatrix', function () { var m = this.pop(); m.a = this.gs.ctm.slice(); this.push(m); });
    d('defaultmatrix', function () { var m = this.pop(); m.a = this.baseCtm.slice(); this.push(m); });
    d('setmatrix', function () { this.gs.ctm = this.pop().a.slice(); });
    d('initmatrix', function () { this.gs.ctm = this.baseCtm.slice(); });
    var mat = function (fn) { return function () { var t = this.os[this.os.length - 1]; if (t instanceof PSArr && t.a.length === 6 && !t.x) { var m = this.pop(); var r = fn.call(this, null); m.a = r; this.push(m); } else fn.call(this, true); }; };
    d('translate', mat(function (apply) { var y = this.num(), x = this.num(), m = [1, 0, 0, 1, x, y]; if (apply) this.gs.ctm = mmul(m, this.gs.ctm); return m; }));
    d('scale', mat(function (apply) { var y = this.num(), x = this.num(), m = [x, 0, 0, y, 0, 0]; if (apply) this.gs.ctm = mmul(m, this.gs.ctm); return m; }));
    d('rotate', mat(function (apply) { var a = this.num() * Math.PI / 180, c = Math.cos(a), s = Math.sin(a), m = [c, s, -s, c, 0, 0]; if (apply) this.gs.ctm = mmul(m, this.gs.ctm); return m; }));
    d('concat', function () { var m = this.pop(); this.gs.ctm = mmul(m.a, this.gs.ctm); });
    d('concatmatrix', function () { var m3 = this.pop(), m2 = this.pop(), m1 = this.pop(); m3.a = mmul(m1.a, m2.a); this.push(m3); });
    d('invertmatrix', function () { var m2 = this.pop(), m1 = this.pop(); m2.a = minv(m1.a) || [1, 0, 0, 1, 0, 0]; this.push(m2); });
    var xf = function (kind) { return function () {
      var t = this.os[this.os.length - 1], m = this.gs.ctm; if (t instanceof PSArr && !t.x) { m = this.pop().a; }
      var y = this.num(), x = this.num();
      if (kind === 'i' || kind === 'id') m = minv(m) || [1, 0, 0, 1, 0, 0];
      var r = (kind === 'd' || kind === 'id') ? [m[0] * x + m[2] * y, m[1] * x + m[3] * y] : tp(m, x, y); this.push(r[0]); this.push(r[1]);
    }; };
    d('transform', xf('')); d('itransform', xf('i')); d('dtransform', xf('d')); d('idtransform', xf('id'));
    // paths
    d('newpath', function () { this.newPath(); });
    d('moveto', function () { var y = this.num(), x = this.num(); this.moveTo(x, y); });
    d('rmoveto', function () { var y = this.num(), x = this.num(), c = this.userCp(); this.moveTo(c[0] + x, c[1] + y); });
    d('lineto', function () { var y = this.num(), x = this.num(); this.lineTo(x, y); });
    d('rlineto', function () { var y = this.num(), x = this.num(), c = this.userCp(); this.lineTo(c[0] + x, c[1] + y); });
    d('curveto', function () { var v = this.nums(6); this.curveTo(v[0], v[1], v[2], v[3], v[4], v[5]); });
    d('rcurveto', function () { var v = this.nums(6), c = this.userCp(); this.curveTo(c[0] + v[0], c[1] + v[1], c[0] + v[2], c[1] + v[3], c[0] + v[4], c[1] + v[5]); });
    d('closepath', function () { this.closePath(); });
    d('arc', function () { var v = this.nums(5); this.arc(v[0], v[1], v[2], v[3], v[4], false); });
    d('arcn', function () { var v = this.nums(5); this.arc(v[0], v[1], v[2], v[3], v[4], true); });
    d('currentpoint', function () { var c = this.userCp(); this.push(c[0]); this.push(c[1]); });
    d('fill', function () { this.paintFill(false); this.newPath(); });
    d('eofill', function () { this.paintFill(true); this.newPath(); });
    d('stroke', function () { this.paintStroke(); this.newPath(); });
    d('clip', function () { this.clipPath(false); });
    d('eoclip', function () { this.clipPath(true); });
    d('initclip', function () {});
    d('clippath', function () { var b = this.bbox; this.newPath(); this.gs.path = [['m', b[0], b[1]], ['l', b[2], b[1]], ['l', b[2], b[3]], ['l', b[0], b[3]], ['h']]; this.gs.cp = [b[0], b[1]]; });
    d('flattenpath', function () {}); d('reversepath', function () {}); d('strokepath', function () { this.unsup('strokepath'); });
    d('pathbbox', function () {
      var inv = minv(this.gs.ctm) || [1, 0, 0, 1, 0, 0], x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      this.gs.path.forEach(function (s) { for (var k = 1; k < s.length; k += 2) { var q = tp(inv, s[k], s[k + 1]); x0 = Math.min(x0, q[0]); y0 = Math.min(y0, q[1]); x1 = Math.max(x1, q[0]); y1 = Math.max(y1, q[1]); } });
      if (x0 === Infinity) x0 = y0 = x1 = y1 = 0; this.push(x0); this.push(y0); this.push(x1); this.push(y1);
    });
    var rects = function (fn) { return function () {
      var t = this.pop(), list = [];
      if (t instanceof PSArr) { for (var i = 0; i + 3 < t.a.length; i += 4) list.push(t.a.slice(i, i + 4)); }
      else { var h = t, w = this.num(), y = this.num(), x = this.num(); list.push([x, y, w, h]); }
      var save = this.gs.path, cp = this.gs.cp; this.newPath();
      list.forEach(function (r) { this.moveTo(r[0], r[1]); this.lineTo(r[0] + r[2], r[1]); this.lineTo(r[0] + r[2], r[1] + r[3]); this.lineTo(r[0], r[1] + r[3]); this.closePath(); }, this);
      fn.call(this); if (fn.keep) return; this.gs.path = save; this.gs.cp = cp;
    }; };
    d('rectfill', rects(function () { this.paintFill(false); }));
    d('rectstroke', rects(function () { this.paintStroke(); }));
    var rc = function () { this.clipPath(false); this.newPath(); }; rc.keep = true; d('rectclip', rects(rc));
    d('shfill', function () {
      var dd = this.pop(); if (!(dd instanceof PSDict)) this.unsup('shading');
      var t = dd.m.get('ShadingType'); var text;
      if (t >= 4) text = this.streamFromDict(dd, null);
      else { var c = new PSDict(); dd.m.forEach(function (v, k) { if (k !== 'Background') c.m.set(k, v); }); text = this.pdf.add(this.toPdf(c)) + ' 0 R'; }
      var nm = '/Sh' + this.addRes('sh', text);
      this.ops.push('q ' + this.gs.ctm.map(fmt).join(' ') + ' cm ' + nm + ' sh Q'); this.paints++;
    });
    // images
    d('image', function () {
      var t = this.pop();
      if (t instanceof PSDict) { this.imageDict(t, false); return; }
      var src = t, m = this.pop(), bpc = this.num(), h = this.num(), w = this.num();
      this.doImage({ w: w, h: h, bpc: bpc, cs: '/DeviceGray', n: 1, matrix: m.a, src: src });
    });
    d('imagemask', function () {
      var t = this.pop();
      if (t instanceof PSDict) { this.imageDict(t, true); return; }
      var src = t, m = this.pop(), pol = this.pop(), h = this.num(), w = this.num();
      this.doImage({ w: w, h: h, bpc: 1, n: 1, matrix: m.a, src: src, mask: true, polarity: pol === true });
    });
    d('colorimage', function () {
      var nc = this.num(), multi = this.pop(); if (multi) this.unsup('multiple data sources');
      var src = this.pop(), m = this.pop(), bpc = this.num(), h = this.num(), w = this.num();
      this.doImage({ w: w, h: h, bpc: bpc, cs: nc === 4 ? '/DeviceCMYK' : (nc === 3 ? '/DeviceRGB' : '/DeviceGray'), n: nc, matrix: m.a, src: src });
    });
  };

  // files read through a different interpreter (string sources)
  var _readFileBytes = PS.prototype.readFileBytes, _capture = PS.prototype.capture;
  PS.prototype.readFileBytes = function (src, n, hex) { if (src instanceof PSFile && src.it !== this) return src.it.readFileBytes(src, n, hex); return _readFileBytes.call(this, src, n, hex); };
  PS.prototype.capture = function (src) { var x = src; while (x instanceof PSFilter) x = x.src; if (x instanceof PSFile && x.it !== this) { var r = _capture.call(x.it, src); return r; } return _capture.call(this, src); };

  // ---- dialects ----
  PS.prototype.fontOps = function () {
    var d = this.def.bind(this);
    d('findfont', function () { this.pop(); this.push(new PSDict()); });
    d('scalefont', function () { this.pop(); this.pop(); this.push(new PSDict()); });
    d('makefont', function () { this.pop(); this.pop(); this.push(new PSDict()); });
    d('definefont', function () { var f = this.pop(); this.pop(); this.push(f instanceof PSDict ? f : new PSDict()); });
    d('composefont', function () { this.pop(); this.pop(); this.pop(); this.push(new PSDict()); });
    d('findencoding', function () { this.pop(); this.push(new PSArr([], false)); });
  };
  PS.prototype.agm = function () {
    var S = this, al = function (a, b) { S.alias(a, b); }, d = function (n, f) { S.def(n, f); };
    al('mo', 'moveto'); al('li', 'lineto'); al('cv', 'curveto'); al('cp', 'closepath'); al('np', 'newpath');
    al('f', 'fill'); al('ef', 'eofill'); al('@', 'stroke'); al('ct', 'concat'); al('cf', 'currentfile'); al('fl', 'filter'); al('rs', 'readstring');
    al('gry', 'setgray'); al('rgb', 'setrgbcolor'); al('lw', 'setlinewidth'); al('lc', 'setlinecap'); al('lj', 'setlinejoin'); al('ml', 'setmiterlimit'); al('dsh', 'setdash');
    al('sadj', 'setstrokeadjust'); al('sop', 'setoverprint'); al('colr', 'setcolor');
    d('cmyk', function () { this.setColor('DeviceCMYK', this.nums(4)); });
    d('clp', function () { this.clipPath(false); this.newPath(); });
    d('eclp', function () { this.clipPath(true); this.newPath(); });
    d('nclp', function () { this.newPath(); });
    d('pgsv', function () { this.gsave(); this.pgDepth = this.gstack.length; });
    d('pgrs', function () { while (this.gstack.length >= (this.pgDepth || 1) && this.gstack.length) this.grestore(); });
    d('level2', function () { this.push(true); }); d('level3', function () { this.push(true); });
    d('sepcs', function () { var v = this.pop(); if (typeof this.os[this.os.length - 1] === 'number' && !(v instanceof PSDict)) this.pop(); var inf = this.sepCsd(v).info; this.setColor({ pdf: inf.pdf, n: 1 }, [1]); });
    d('sep', function () { var t = this.num(); var cs = this.gs.fill.cs; this.setColor(cs, [t]); });
    d('csacrd', function () { var dd = this.pop(); var csa = dd instanceof PSDict ? dd.m.get('CSA') : dd; this.setColorSpace(csa); });
    d('gset', function () { this.gsave(); var m = this.pop(); if (m instanceof PSArr) this.gs.ctm = mmul(m.a, this.gs.ctm); this.setColor('DeviceGray', [0]); this.gs.lw = 1; });
    d('gcln', function () { this.grestore(); });
    ['img', 'sepimg', 'idximg', 'devnimg'].forEach(function (n) { d(n, function () { var dd = this.pop(); if (!(dd instanceof PSDict)) this.unsup('image'); var op = dd.m.get('Operator'); this.imageDict(dd, op instanceof PSName && op.v === 'imagemask'); }); });
    ['devncs', 'devn', 'idx', 'knockout_unitsq'].forEach(function (n) { d(n, function () { this.unsup(n); }); });
  };
  PS.prototype.aiFormat = function () {
    var S = this, d = function (n, f) { S.def(n, f); };
    var paint = function (close, fill, stroke) {
      return function () {
        if (close) this.closePath();
        if (this.compound) { this.lastPaint = [fill, stroke]; if (this.pendingClip) this.lastClip = true; return; }
        this.finishPaint(fill, stroke);
      };
    };
    S.finishPaint = function (fill, stroke) {
      if (this.pendingClip) { this.clipPath(this.fillRule === 1); this.pendingClip = 0; }
      if (fill) this.paintFill(this.fillRule === 1);
      if (stroke) this.paintStroke();
      this.newPath();
    };
    d('m', function () { var y = this.num(), x = this.num(); this.moveTo(x, y); });
    d('l', function () { var y = this.num(), x = this.num(); this.lineTo(x, y); }); this.alias('L', 'l');
    d('c', function () { var v = this.nums(6); this.curveTo(v[0], v[1], v[2], v[3], v[4], v[5]); }); this.alias('C', 'c');
    d('v', function () { var v = this.nums(4), c = this.userCp(); this.curveTo(c[0], c[1], v[0], v[1], v[2], v[3]); }); this.alias('V', 'v');
    d('y', function () { var v = this.nums(4); this.curveTo(v[0], v[1], v[2], v[3], v[2], v[3]); }); this.alias('Y', 'y');
    d('N', paint(false, false, false)); d('n', paint(true, false, false)); this.alias('H', 'N'); this.alias('h', 'n');
    d('F', paint(false, true, false)); d('f', paint(true, true, false));
    d('S', paint(false, false, true)); d('s', paint(true, false, true));
    d('B', paint(false, true, true)); d('b', paint(true, true, true));
    d('W', function () { this.pendingClip = 1; });
    d('*u', function () { this.compound = 1; this.lastPaint = null; this.lastClip = false; });
    d('*U', function () { this.compound = 0; if (this.lastClip) this.pendingClip = 1; var lp = this.lastPaint || [false, false]; this.finishPaint(lp[0], lp[1]); });
    d('u', function () {}); d('U', function () {});
    d('q', function () { this.gsave(); }); d('Q', function () { this.grestore(); });
    d('D', function () { this.fillRule = this.num() ? 1 : 0; });
    d('w', function () { this.gs.lw = this.num(); }); d('j', function () { this.gs.join = this.num() & 3; }); d('J', function () { this.gs.cap = this.num() & 3; });
    d('M', function () { this.gs.ml = this.num(); }); d('d', function () { var ph = this.num(), a = this.pop(); this.gs.dash = [a instanceof PSArr ? a.a : [], ph]; });
    d('g', function () { this.setColor('DeviceGray', [this.num()], 'fill'); }); d('G', function () { this.setColor('DeviceGray', [this.num()], 'stroke'); });
    d('k', function () { this.setColor('DeviceCMYK', this.nums(4), 'fill'); }); d('K', function () { this.setColor('DeviceCMYK', this.nums(4), 'stroke'); });
    d('Xa', function () { this.setColor('DeviceRGB', this.nums(3), 'fill'); }); d('XA', function () { this.setColor('DeviceRGB', this.nums(3), 'stroke'); });
    var custom = function (which, typed) {
      return function () {
        var type = typed ? this.num() : 0, tint = this.num(); this.pop();
        var c = this.nums(type === 1 ? 3 : 4), f = 1 - tint;
        if (type === 1) this.setColor('DeviceRGB', c.map(function (x) { return 1 - (1 - x) * f; }), which);
        else this.setColor('DeviceCMYK', c.map(function (x) { return x * f; }), which);
      };
    };
    d('x', custom('fill', false)); d('X', custom('stroke', false)); d('Xx', custom('fill', true)); d('XX', custom('stroke', true));
    ['A', 'O', 'R', 'XR', 'Ap', 'Ar', 'Ln', 'LN', 'Lb', 'LB', 'Np', 'XW', 'XT', 'Xy', 'XY', 'XP', 'Xn', 'Xs', 'Xm', 'Xd', 'XD', 'Xw', 'XN'].forEach(function (n) { d(n, function () {}); });
    ['To', 'TO', 'Tp', 'TP', 'Tx', 'TX', 'Tj', 'Tk', 'XI', 'XG', 'XF', 'XJ', 'Bg', 'Bb', 'p', 'P', 'E', 'Xb', 'XB'].forEach(function (n) { d(n, function () { this.unsup(n); }); });
  };

  // ---- run an EPS (or PostScript AI) file -> PDF bytes ----
  function dscBox(hdr) {
    var m = /%%HiResBoundingBox:\s*([-\d.eE+]+)\s+([-\d.eE+]+)\s+([-\d.eE+]+)\s+([-\d.eE+]+)/.exec(hdr) || /%%BoundingBox:\s*([-\d.eE+]+)\s+([-\d.eE+]+)\s+([-\d.eE+]+)\s+([-\d.eE+]+)/.exec(hdr);
    if (!m) return null;
    var b = [+m[1], +m[2], +m[3], +m[4]]; if (!(b[2] > b[0] && b[3] > b[1])) return null; return b;
  }
  function epsParts(bytes) {
    var ps = bytes, tiff = null;
    if (bytes[0] === 0xC5 && bytes[1] === 0xD0 && bytes[2] === 0xD3 && bytes[3] === 0xC6) {
      var dv = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
      var psOff = dv.getUint32(4, true), psLen = dv.getUint32(8, true), tOff = dv.getUint32(20, true), tLen = dv.getUint32(24, true);
      ps = bytes.subarray(psOff, Math.min(bytes.length, psOff + psLen));
      if (tLen && tOff + tLen <= bytes.length) tiff = bytes.subarray(tOff, tOff + tLen);
    }
    var head = latin1(ps, 0, Math.min(ps.length, 200000)), box = dscBox(head);
    if (!box || /%%BoundingBox:\s*\(atend\)/.test(head)) box = dscBox(latin1(ps, Math.max(0, ps.length - 200000), ps.length)) || box;
    return { ps: ps, tiff: tiff, box: box, head: head };
  }
  function findLineEnd(s, i) { var j = s.indexOf('\n', i); var k = s.indexOf('\r', i); if (j < 0) j = s.length; if (k >= 0 && k < j) j = k; return j; }
  function epsToPdf(parts) {
    var ps = parts.ps, box = parts.box;
    if (!box) throw new Unsupported('no bounding box');
    var text = latin1(ps), dialect, start = 0, end = ps.length;
    var trail = function (from) { var t = text.indexOf('%%PageTrailer', from); if (t < 0) t = text.indexOf('%%Trailer', from); return t < 0 ? ps.length : t; };
    if (text.indexOf('Adobe_AGM_Core') >= 0) {
      dialect = 'agm';
      var e1 = text.indexOf('%%EndPageSetup'); if (e1 < 0) e1 = text.indexOf('%%EndSetup');
      if (e1 < 0) throw new Unsupported('no page setup');
      start = findLineEnd(text, e1); end = trail(start);
    } else if (/Adobe_Illustrator|%AI3_|%AI5_|%%Creator:\s*\(?Adobe Illustrator/.test(parts.head) && text.indexOf('%%EndSetup') >= 0) {
      dialect = 'ai';
      start = findLineEnd(text, text.indexOf('%%EndSetup')); end = trail(start);
    } else dialect = 'generic';
    var it = new PS(ps, start, end, dialect);
    it.fontOps();
    if (dialect === 'agm') it.agm(); else if (dialect === 'ai') it.aiFormat();
    it.baseCtm = [1, 0, 0, 1, 0, 0]; it.bbox = box;
    try { it.run(); } catch (e) { if (e instanceof Unsupported) throw e; if (e instanceof StopSig) {} else throw new Unsupported((e && e.message) || 'error'); }
    if (it.unsupported) throw new Unsupported(it.unsupported);
    var unknown = Object.keys(it.unknown).filter(function (n) { return !/^(pdfmark|setdistillerparams|annotatepage)$/.test(n); });
    if (dialect !== 'ai' && unknown.length) throw new Unsupported('unknown: ' + unknown.slice(0, 6).join(' '));
    if (!it.paints) throw new Unsupported('nothing drawn');
    while (it.gstack.length) it.grestore();
    var body = it.ops.join('\n'), cb = new Uint8Array(body.length); for (var i = 0; i < body.length; i++) cb[i] = body.charCodeAt(i) & 255;
    var resParts = [];
    if (it.res.cs.length) resParts.push('/ColorSpace << ' + it.res.cs.map(function (t, i2) { return '/CS' + i2 + ' ' + t; }).join(' ') + ' >>');
    if (it.res.sh.length) resParts.push('/Shading << ' + it.res.sh.map(function (t, i2) { return '/Sh' + i2 + ' ' + t; }).join(' ') + ' >>');
    if (it.res.xo.length) resParts.push('/XObject << ' + it.res.xo.map(function (t, i2) { return '/Im' + i2 + ' ' + t; }).join(' ') + ' >>');
    var contents = it.pdf.add('<< >>', cb);
    var pagesId = it.pdf.objs.length + 1, pageId = it.pdf.add('<< /Type /Page /Parent ' + pagesId + ' 0 R /MediaBox [' + box.map(fmt).join(' ') + '] /Resources << ' + resParts.join(' ') + ' >> /Contents ' + contents + ' 0 R >>');
    it.pdf.add('<< /Type /Pages /Kids [' + pageId + ' 0 R] /Count 1 >>');
    return it.pdf.bytes('<< /Type /Catalog /Pages ' + pagesId + ' 0 R >>');
  }
  function epsiPreview(text) {
    var m = /%%BeginPreview:\s*(\d+)\s+(\d+)\s+(\d+)\s+(\d+)/.exec(text);
    if (!m) return null;
    var w = +m[1], h = +m[2], depth = +m[3];
    if (w < 300 && h < 300) return null;
    var s = text.indexOf('\n', m.index) + 1, e = text.indexOf('%%EndPreview', s); if (e < 0) return null;
    var hex = text.slice(s, e).replace(/[^0-9A-Fa-f]/g, ''), bytes = new Uint8Array(hex.length >> 1);
    for (var i = 0; i < bytes.length; i++) bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
    var cv = makeCanvas(w, h), ctx = cv.getContext('2d'), img = ctx.createImageData(w, h), rowB = Math.ceil(w * depth / 8), ones = 0, total = 0;
    var val = function (y, x) { if (depth === 8) return bytes[y * rowB + x]; var bit = x * depth, by = bytes[y * rowB + (bit >> 3)], sh = 8 - depth - (bit & 7); return Math.round(((by >> sh) & ((1 << depth) - 1)) * 255 / ((1 << depth) - 1)); };
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) { var v = val(y, x); total++; if (v > 127) ones++; }
    var inv = ones / total > 0.5 ? false : true; // most previews are mostly white
    for (var y2 = 0; y2 < h; y2++) for (var x2 = 0; x2 < w; x2++) { var g = val(y2, x2); if (inv) g = 255 - g; var o = (y2 * w + x2) * 4; img.data[o] = img.data[o + 1] = img.data[o + 2] = g; img.data[o + 3] = 255; }
    ctx.putImageData(img, 0, 0);
    return cv;
  }

  // ---------- public API ----------
  function fitCanvas(cv, maxPx) {
    var s = Math.min(1, maxPx / Math.max(cv.width, cv.height), Math.sqrt(MAX_AREA / (cv.width * cv.height)));
    if (s >= 1) return cv;
    var o = makeCanvas(cv.width * s, cv.height * s), x = o.getContext('2d');
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    x.drawImage(cv, 0, 0, o.width, o.height);
    return o;
  }
  function fail(reason, detail) { return { ok: false, reason: reason, detail: detail || '' }; }
  function previewPdfBytes(bytes, maxPx, kind) {
    return renderPdf(bytes, maxPx).then(function (r) {
      if (/saved without PDF Content/i.test(r.text || '')) return fail('ai-no-pdf');
      if (isBlank(r.canvas)) return fail('blank');
      return { ok: true, kind: kind, canvas: r.canvas, natW: r.natW, natH: r.natH, vectorPdf: null };
    }, function (e) {
      var m = (e && (e.name + ' ' + e.message)) || '';
      if (/password/i.test(m)) return fail('locked', m);
      return fail('pdf', m);
    });
  }
  function previewEps(bytes, maxPx) {
    var parts = epsParts(bytes), why = '';
    var vector = Promise.resolve(null);
    try {
      var pdf = epsToPdf(parts);
      vector = renderPdf(pdf, maxPx).then(function (r) {
        if (isBlank(r.canvas)) return null;
        return { ok: true, kind: 'eps', canvas: r.canvas, natW: r.natW, natH: r.natH, vectorPdf: pdf };
      }).catch(function (e) { why = 'render: ' + ((e && e.message) || e); return null; });
    } catch (e) { why = (e && (e.msg || e.message)) || String(e); }
    return vector.then(function (res) {
      if (res) return res;
      var box = parts.box, done = function (cv, src) {
        if (!cv) return null;
        var nw = box ? box[2] - box[0] : cv.width, nh = box ? box[3] - box[1] : cv.height;
        return { ok: true, kind: 'eps', canvas: fitCanvas(cv, maxPx), natW: nw, natH: nh, vectorPdf: null, note: 'preview:' + src, why: why };
      };
      var tiffP = parts.tiff ? decodeTiff(parts.tiff).then(function (cv) { return done(cv, 'tiff'); }).catch(function () { return null; }) : Promise.resolve(null);
      return tiffP.then(function (r) {
        if (r) return r;
        var cv = null; try { cv = epsiPreview(parts.head + latin1(parts.ps, parts.head.length, Math.min(parts.ps.length, parts.head.length + 4000000))); } catch (e) {}
        if (cv) return done(cv, 'epsi');
        return fail('eps', why);
      });
    });
  }
  function preview(file, opts) {
    opts = opts || {};
    var maxPx = opts.maxPx || 2400;
    return file.arrayBuffer().then(function (ab) {
      var b = new Uint8Array(ab), head = latin1(b, 0, Math.min(b.length, 1024));
      if (head.indexOf('%PDF') >= 0) return previewPdfBytes(b, maxPx, /\.ai$/i.test(file.name || '') ? 'ai' : 'pdf');
      if ((b[0] === 0xC5 && b[1] === 0xD0 && b[2] === 0xD3 && b[3] === 0xC6) || head.indexOf('%!PS') === 0) return previewEps(b, maxPx);
      if ((b[0] === 0x49 && b[1] === 0x49 && b[2] === 42) || (b[0] === 0x4D && b[1] === 0x4D && b[3] === 42)) return decodeTiff(b).then(function (cv) { return { ok: true, kind: 'tiff', canvas: fitCanvas(cv, maxPx), natW: cv.width, natH: cv.height }; }, function (e) { return fail('tiff', e && e.message); });
      if (head.indexOf('8BPS') === 0) return decodePsd(b).then(function (cv) { return { ok: true, kind: 'psd', canvas: fitCanvas(cv, maxPx), natW: cv.width, natH: cv.height }; }, function (e) { return fail('psd', e && e.message); });
      return fail('type');
    }).catch(function (e) { return fail('read', e && e.message); });
  }

  window.ArdorBannerArtView = {
    config: function (u) { if (u && u.lib) URLS.lib = u.lib; if (u && u.worker) URLS.worker = u.worker; },
    preview: preview,
    _epsToPdf: function (bytes) { return epsToPdf(epsParts(bytes)); },
    _renderPdf: renderPdf
  };
})();
